<template>
  <div class="d-block px-2 py-3">
    <!-- modal konfirmasi pembayaran -->
    <modalConfirm ref="modalConfirm" confirm-text="Yakin" @action="confirmPayment" confirmColor="primary">
      <template v-slot:title>
        <span class="primary--text text-capitalize font-weight-bold">Konfirmasi</span>
      </template>
      <template v-slot:body>
        <div class="text-center">Apakah Anda yakin untuk melakukan konfirmasi pembayaran?</div>
      </template>
    </modalConfirm>

    <!-- modal konfirmasi cancel transaksi -->
    <modalConfirm ref="modalCancel" confirm-text="Yakin" @action="rejectPesananAct" confirmColor="error">
      <template v-slot:title>
        <span class="primary--text text-capitalize font-weight-bold">Konfirmasi</span>
      </template>
      <template v-slot:body>
        <div class="text-center" v-if="selectedItem">Apakah Anda yakin untuk menolak transaksi <b style="color: darkred;">{{ selectedItem.trx_dropship_code }}</b>?</div>
      </template>
    </modalConfirm>

    <!-- Filter data -->
    <v-card outlined elevation="0" id="filter-card" class="my-5">
      <v-card-text>
        <v-form>
          <v-row>
            <v-col cols="12" sm="3" class="py-0" :class="{'mb-2': isMobile}">
              <v-menu
                ref="menuDate"
                v-model="menuDate"
                :close-on-content-click="true"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="dateRangeText"
                    prepend-inner-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    hide-details="auto"
                    outlined
                    clearable
                    densed
                    class="datePickerSmall"
                    placeholder="Tanggal"
                    @click:clear="clearDate"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="filter.dateRange"
                  no-title
                  @click:date="searchTrx"
                  @change="tglTransaksiFilter.value = filter.dateRange"
                >
                </v-date-picker>
              </v-menu>
            </v-col>
            
            <v-col cols="12" sm="3" class="py-0" :class="{'mb-2': isMobile}">
              <v-combobox
                v-model="filter.type"
                dense
                outlined
                item-text="label"
                item-value="value"
                hide-details="auto"
                :items="filterOptions"
              ></v-combobox>
            </v-col>

            <v-col cols="12" sm="6" class="py-0" :class="{'mb-2': isMobile}">
              <v-text-field
                v-model="filter.search"
                outlined
                small
                dense
                clearable
                hide-details="auto"
                class="searchInput"
                @input="buyerNameFilter.value = filter.search, invoiceNoFilter.value = filter.search"
                @click:clear="clearSearch"
                @keyup.enter="searchTrx"
                placeholder="Masukkan kata kunci"
              >
                <div slot="append">
                  <v-btn
                    small
                    elevation="2"
                    color="success"
                    @click="searchTrx"
                  >
                    <v-icon center>
                      mdi-magnify
                    </v-icon>
                  </v-btn>
                </div>
              </v-text-field>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>

    <!-- list data pesanan -->
    <v-layout v-resize="onResize" column>
      <v-data-table
        v-model="selected"
        :server-items-length="transaksiDropshipper.pagination.total_data"
        :items="transaksiDropshipper.lists"
        :loading="loadingList"
        :headers="headers"
        :expanded.sync="expanded"
        :hide-default-header="true"
        :hide-default-footer="true"
        mobile-breakpoint="600"
        item-key="trx_dropship_id"
        show-expand
        single-expand
        class="elevation-1 border"
        :class="{mobile: isMobile}"
        id="order-table"
        @item-expanded="loadDetailTransaksiDropshipper"
      >
        <template v-slot:item.trx_code="{ item }">
          <v-row class="d-flex align-start pa-3" :class="(isMobile) ? 'flex-column' : 'flex-row'">
            <v-col cols="12" sm="4" class="d-flex flex-column align-start justify-start" :class="{'mb-3 pa-0': isMobile}">
              <div class="d-flex flex-column justify-start text-left">
                <strong>No. Transaksi</strong>
                <router-link :to="'/seller/pesanan-dropship'" class="font-weight-bold no-line">{{ item.trx_dropship_code }}</router-link>
              </div>
            </v-col>
            
            <v-col cols="12" sm="3" class="text-subtitle-2 d-flex flex-column align-start" :class="{'mb-3 pa-0': isMobile}">
              <div class="d-flex flex-column justify-start text-left">
                <strong>Tanggal Pemesanan</strong>
                <span class="pl-0">{{ formatDateText(item.trx_dropship_datetime, 'DD MMM YYYY HH:mm') }}</span>
              </div>
            </v-col>
            <v-col cols="12" sm="4" class="text-subtitle-2 black-text font-weight-bold" :class="(isMobile) ? 'mb-3 mx-0 pa-0' : 'mx-5 px-0'">
              <div class="d-flex flex-column justify-start text-left">
                <strong>Status Transaksi</strong>
                <v-chip
                  small
                  label
                  class="font-weight-bold"
                  :class="colorStatus(item.trx_dropship_status)"
                >{{ item.trx_dropship_status }}</v-chip>
              </div>
            </v-col>
          </v-row>
        </template>

        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length" class="mb-2" v-if="!loadingDetail">
            <template v-if="(detailTransaksiDropshipper && detailTransaksiDropshipper !== undefined)">
              <v-row class="mb-1">
                <v-col cols="12" sm="12" class="text-left mb-2" v-if="detailTransaksiDropshipper.trx_dropship_status == 'Diterima'">
                  <v-alert
                    text
                    type="error"
                    class="mb-0"
                    dense
                  >
                    <span class="d-block">Pesanan akan Selesai otomatis pada : <b style="color: darkred;">{{ detailTransaksiDropshipper.trx_dropship_done_datetime | tanggaljam }}</b>.</span>
                  </v-alert>
                </v-col>

                <v-col cols="12" sm="5" class="text-left" :class="{'pb-0': isMobile}">
                  <div class="text-subtitle-2 font-weight-bold black--text mb-1">Info Produk</div>
                  <hr class="my-3">
                  <template v-if="(detailTransaksiDropshipper.trx_dropship_detail !== undefined)">
                    <template v-for="(produk, idp) in detailTransaksiDropshipper.trx_dropship_detail">
                      <div :key="idp" class="d-flex flex-row align-start" :class="(isMobile) ? 'mb-0' : 'mb-4'">
                        <v-img width="80" max-width="80" class="mr-4" :src="(produk.trx_dropship_detail_product_image !== '') ? produk.trx_dropship_detail_product_image : '/assets/product/default.png'"></v-img>
                        <div class="d-flex flex-column align-start">
                          <div class="font-weight-bold no-line green--text">{{ produk.trx_dropship_detail_product_name }}</div>
                          <div class="text-caption">{{ produk.trx_dropship_detail_quantity }} barang ({{ produk.trx_dropship_detail_product_weight | toKg }}) @ {{ (produk.trx_dropship_detail_product_price) | toRupiah }} </div>
                          <div class="text-caption">Subtotal : <strong>{{ (produk.trx_dropship_detail_product_price * produk.trx_dropship_detail_quantity) | toRupiah }}</strong></div>
                        </div>
                      </div>
                    </template>
                  </template>
                </v-col>

                <v-col cols="12" sm="1"></v-col>

                <v-col cols="12" sm="6" class="text-left" :class="{'pl-0' : !isMobile}">
                  <div class="d-flex flex-column align-start mb-4" v-if="Object.keys(detailTransaksiDropshipper).length > 0">
                    <div class="text-subtitle-2 font-weight-bold black--text mb-1">Informasi Pembeli</div>
                    <span class="text-caption"><strong>{{ detailTransaksiDropshipper.buyer.buyer_name }}</strong>  ({{ detailTransaksiDropshipper.buyer.buyer_phone }})</span>
                  </div>

                  <div class="d-flex flex-column align-start mb-4" v-if="Object.keys(detailTransaksiDropshipper).length > 0">
                    <div class="text-subtitle-2 font-weight-bold black--text mb-1">Informasi Dropshipper</div>
                    <span class="text-caption"><strong>{{ detailTransaksiDropshipper.seller.store_name }}</strong>  ({{ detailTransaksiDropshipper.seller.store_phone }})</span>
                  </div>

                  <hr class="my-2">

                  <div class="d-flex flex-row align-center justify-space-between">
                    <div class="text-subtitle-2 font-weight-bold black--text mb-1">Total Belanja</div>
                    <span class="text-subtitle-2 font-weight-bold green--text">{{ detailTransaksiDropshipper.trx_dropship_subtotal_price | toRupiah }}</span>
                  </div>

                  <div class="d-flex flex-row align-center justify-space-between">
                    <div class="text-subtitle-2 font-weight-bold black--text mb-1">Ongkos Kirim</div>
                    <span class="text-subtitle-2 font-weight-bold green--text">{{ detailTransaksiDropshipper.trx_dropship_shipping_cost | toRupiah }}</span>
                  </div>

                  <hr class="my-2">
                  
                  <div class="d-flex flex-row align-center justify-space-between mt-3">
                    <div class="text-subtitle-2 font-weight-bold black--text mb-1">Total Harga</div>
                    <span class="text-subtitle-1 font-weight-bold green--text">{{ detailTransaksiDropshipper.trx_dropship_grand_total | toRupiah }}</span>
                  </div>
                </v-col>
              </v-row>

              <!-- info Pengiriman -->
              <template v-if="Object.keys(detailTransaksiDropshipper).length > 0 && detailTransaksiDropshipper.trx_dropship_status !== 'Menunggu Diproses'">
                <v-row class="mb-1 align-start px-3 mb-4 border">
                  <v-col cols="12" :sm="(detailTransaksiDropshipper.trx_dropship_status === 'Diproses') ? '6' : '6'" class="text-left" :class="{'pl-0' : !isMobile}">
                    <div class="d-flex flex-column align-start text-capitalize">
                      <div class="text-subtitle-2 font-weight-bold black--text mb-1">Alamat Pengiriman</div>
                      <span class="text-caption font-weight-bold text-capitalize">{{ detailTransaksiDropshipper.trx_shipping.trx_shipping_courier_receiver_name }}</span>
                      <span class="text-caption">{{ detailTransaksiDropshipper.trx_shipping.trx_shipping_courier_destination_address }},</span>
                      <span class="text-caption">{{ detailTransaksiDropshipper.trx_shipping.trx_shipping_courier_destination_sub_district_name }} {{ detailTransaksiDropshipper.trx_shipping.trx_shipping_courier_destination_district_name }} {{ detailTransaksiDropshipper.trx_shipping.trx_shipping_courier_destination_city_name }} {{ detailTransaksiDropshipper.trx_shipping.trx_shipping_courier_destination_province_name }}</span>
                      <span class="text-caption">Telp. {{ detailTransaksiDropshipper.trx_shipping.trx_shipping_courier_receiver_phone }},</span>
                    </div>
                  </v-col>

                  <v-col cols="12" :sm="(detailTransaksiDropshipper.trx_dropship_status === 'Diproses') ? '6' : '6'" class="text-left" :class="{'pl-0' : !isMobile}">
                    <template>
                      <div class="d-flex flex-column align-start">
                        <div class="text-subtitle-2 font-weight-bold black--text mb-2">Kurir Pengiriman</div>
                        <div class="d-flex flex-row">
                          <v-img contain width="80" max-width="80" class="mr-4" :src="(detailTransaksiDropshipper.trx_dropship_shipping.trx_dropship_shipping_courier_logo_url !== '') ? detailTransaksiDropshipper.trx_dropship_shipping.trx_dropship_shipping_courier_logo_url : '/assets/product/default.png'"></v-img>
                          <div class="d-flex flex-column">
                            <span class="text-caption">{{ (detailTransaksiDropshipper.trx_dropship_shipping.trx_dropship_shipping_courier_name) ? detailTransaksiDropshipper.trx_dropship_shipping.trx_dropship_shipping_courier_name.toUpperCase() : '' }} {{ detailTransaksiDropshipper.trx_dropship_shipping.trx_dropship_shipping_courier_service }}</span>
                            <!-- <span class="text-caption">({{ detailTransaksiDropshipper.trx_dropship_shipping.trx_courier_etd }})</span> -->
                            <span class="text-caption font-weight-bold">{{ detailTransaksiDropshipper.trx_dropship_shipping_cost | toRupiah }}</span>
                          </div>
                        </div>
                        <span class="d-block mt-3" v-if="detailTransaksiDropshipper.trx_dropship_shipping.trx_dropship_shipping_courier_awb_number !== undefined "><b>No. Resi :</b> {{ detailTransaksiDropshipper.trx_dropship_shipping.trx_dropship_shipping_courier_awb_number | emptyData}}</span>
                      </div>
                    </template>
                  </v-col>

                  <v-col cols="12" sm="12" class="text-left" v-if="(detailTransaksiDropshipper.trx_dropship_status !== 'Menunggu Diproses')">
                    <v-form ref="formKirimPesanan" role="form">
                      <v-row class="mb-1 align-start" v-if="detailTransaksiDropshipper.trx_dropship_status === 'Diproses'">
                        <!-- Bagian opsi pengiriman -->
                        <v-col cols="12" md="12" class="text-left pt-0 px-0" v-if="detailTransaksiDropshipper.trx_dropship_status === 'Diproses'">
                          <v-card outlined>
                            <v-card-title>
                              <v-icon
                                :left="true"
                                class="d-inline primary--text"
                                dense
                              >
                                mdi-truck
                              </v-icon>
                              <small class="primary--text" style="font-weight: 600;">Metode Pengiriman Pesanan</small>
                            </v-card-title>
                            <v-card-text>
                              <v-radio-group row class="mt-0" v-model="shippingMethodSelected">
                                <template v-for="shipping in shippingMethod">
                                  <v-radio :label="(shipping == 'Drop') ? 'Drop Off' : shipping" :value="shipping" :key="shipping" class="mr-5"></v-radio>
                                </template>
                              </v-radio-group>
                            </v-card-text>
                          </v-card>
                        </v-col>
                        <!-- Bagian opsi pengiriman -->

                        <!-- Bagian isi resi kurir -->
                        <v-col cols="12" sm="12" class="text-left pt-0" :class="{ 'pl-0': !isMobile }" v-if="shippingMethodSelected == 'Manual'">
                          <div class="d-flex flex-column align-start">
                            <div class="text-subtitle-2 font-weight-bold black--text mb-1 align-center">
                              Nomor Resi
                              <v-chip
                                x-small
                                label
                                color="green"
                                outlined
                                class="ml-2 font-weight-bold"
                              >Wajib Dicantumkan</v-chip>
                            </div>
                          </div>

                          <template>
                            <span v-if="detailTransaksiDropshipper.trx_dropship_shipping.trx_dropship_shipping_courier_awb_number">No. Resi : {{ detailTransaksiDropshipper.trx_dropship_shipping.trx_dropship_shipping_courier_awb_number | emptyData}}</span>
                            <template v-else>
                              <template v-if="detailTransaksiDropshipper.trx_dropship_status == 'Diproses'">
                                <v-text-field
                                  v-model="courier_resi"
                                  :rules="noresiRules"
                                  outlined
                                  small
                                  dense
                                  full-width
                                  hide-details="auto"
                                  placeholder="Isikan nomor resi pengiriman"
                                  class="mt-1"
                                ></v-text-field>
                              </template>
                              <template v-else>
                                <span>No. Resi : {{ detailTransaksiDropshipper.trx_dropship_shipping.trx_dropship_shipping_courier_awb_number | emptyData}}</span>
                              </template>
                            </template>
                          </template>
                        </v-col>

                        <!-- Bagian opsi pickup time -->
                        <v-col cols="12" md="12" class="text-left pt-0 px-3" v-if="shippingMethodSelected == 'Pickup'">
                          <div class="d-flex flex-column align-start">
                            <div class="text-subtitle-2 font-weight-bold black--text mb-1 align-center">
                              Pilih Waktu Pickup Pesanan
                              <v-chip
                                x-small
                                label
                                color="green"
                                outlined
                                class="ml-2 font-weight-bold"
                              >Wajib Dicantumkan</v-chip>
                            </div>
                          </div>

                          <template>
                            <v-autocomplete
                              v-model="pickup_time"
                              :items="pickupTimeList"
                              :rules="pickupTimeRules"
                              placeholder="Pilih Waktu Pickup"
                              hide-details="auto"
                              outlined
                              dense
                              class="mt-2"
                              @change="cekAllowToShipping"
                            >
                                <template v-slot:selection="{ item }">
                                  <span class="text-capitalize" v-if="pickupTimeList.length > 0">
                                    <v-icon dense class="d-inline mr-2" style="margin-top: -4px;">mdi-clock-outline</v-icon>{{ formatDateText(item.value, 'dddd, DD MMMM YYYY HH:mm') }}
                                  </span>
                                </template>
                                <template v-slot:item="{ item }">
                                  <span class="text-capitalize d-flex align-items-center" v-if="pickupTimeList.length > 0"><v-icon dense class="d-inline mr-2" style="margin-top: -1px;">mdi-clock-outline</v-icon> {{ formatDateText(item.value, 'dddd, DD MMMM YYYY HH:mm') }}</span>
                                </template>
                            </v-autocomplete>
                          </template>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-col>
                </v-row>
              </template>

              <template v-if="detailTransaksiDropshipper.trx_dropship_status != 'Menunggu Pembayaran'">
                <v-row>
                  <!-- general Actions -->
                  <v-col cols="12" sm="6" class="text-left"  :class="(isMobile) ? 'order-2 pt-2' : 'pt-5'">
                    <v-btn
                      outlined
                      dark
                      color="grey"
                      :class="{'v-btn--block': isMobile}"
                      @click="dialogStatusPesanan = true"
                      v-if="false"
                    >
                      <v-img width="20" src="/assets/seller/status-pesanan-no-padding.svg" v-if="!isMobile"></v-img>  
                      <span class="text-subtitle-2 text-capitalize font-weight-bold" :class="{'ml-2': !isMobile}">Status Pesanan</span>
                    </v-btn>

                    <v-btn
                      outlined
                      dark
                      :loading="loadingStatus"
                      color="green"
                      :class="(isMobile) ? 'v-btn--block mb-2' : 'd-none'"
                      @click.native="printInvoice('trx-' + item.trx_dropship_id)"
                      v-if="false"
                    >
                      <!-- v-if="!isMobile && detailTransaksiDropshipper.trx_status != 'Menunggu Pembayaran'" -->
                      <span class="text-subtitle-2 text-capitalize font-weight-bold">Invoice</span>
                    </v-btn>

                    <v-btn
                      color="green"
                      dark
                      class=""
                      :class="(isMobile) ? 'v-btn--block' : 'ml-2'"
                      :loading="loadingTracking"
                      @click="loadTrxTracking(detailTransaksiDropshipper.trx_dropship_id)"
                      v-if="detailTransaksiDropshipper.trx_dropship_status == 'Dikirim' || detailTransaksiDropshipper.trx_dropship_status === 'Selesai' || detailTransaksiDropshipper.trx_dropship_status === 'Diterima'"
                    >
                      <span class="text-subtitle-2 text-capitalize font-weight-bold">Lacak</span>
                    </v-btn>

                    <v-btn
                      color="primary"
                      dark
                      :loading="loadingStatus"
                      :class="(isMobile) ? 'v-btn--block' : 'ml-2'"
                      @click="openBiddingDialog(item)"
                    >
                      <span class="text-subtitle-2 text-capitalize font-weight-bold">Penawaran Komisi Dropshipper</span>
                    </v-btn>
                  </v-col>

                  <!-- Action by TRX Status -->
                  <v-col cols="12" sm="6" class="d-flex align-center justify-end" :class="(isMobile) ? 'order-1 pt-3 flex-column' : 'pt-5 flex-row'">
                    <v-btn
                      color="error"
                      dark
                      outlined
                      class="ml-2"
                      :class="(isMobile) ? 'v-btn--block' : 'ml-2'"
                      @click="dialogCancelOrder = true"
                      v-if="false"
                    >
                      <!-- v-if="!isMobile && detailTransaksiDropshipper.trx_status == 'Menunggu Pembayaran'" -->
                      <span class="text-subtitle-2 text-capitalize font-weight-bold">Batalkan Pesanan</span>
                    </v-btn>

                    <v-btn
                      color="error"
                      dark
                      outlined
                      :loading="loadingStatus"
                      :class="(isMobile) ? 'v-btn--block' : 'ml-2'"
                      @click="openConfirmReject(item)"
                      v-if="detailTransaksiDropshipper.trx_dropship_status == 'Menunggu Diproses'"
                    >
                      <span class="text-subtitle-2 text-capitalize font-weight-bold">Tolak Pesanan</span>
                    </v-btn>

                    <v-btn
                      color="success"
                      dark
                      :loading="loadingStatus"
                      :class="(isMobile) ? 'v-btn--block' : 'ml-2'"
                      @click="openConfirmProses(item)"
                      :disabled="latestKlaim.trx_dropship_profit_sharing_status == 'Disetujui' ? false : true"
                      v-if="detailTransaksiDropshipper.trx_dropship_status === 'Menunggu Diproses'"
                    >
                      <span class="text-subtitle-2 text-capitalize font-weight-bold">Proses Pesanan</span>
                    </v-btn>

                    <v-btn
                      color="success"
                      dark
                      :loading="loadingStatus"
                      :class="(isMobile) ? 'v-btn--block' : 'ml-2'"
                      @click="openConfirmKirim(item)"
                      v-if="detailTransaksiDropshipper.trx_dropship_status === 'Diproses'"
                      :disabled="allowToShipping ? false : true"
                    >
                      <span class="text-subtitle-2 text-capitalize font-weight-bold">Kirim Pesanan</span>
                    </v-btn>

                    <template v-if="detailTransaksiDropshipper.trx_dropship_status == 'Dikirim' || detailTransaksiDropshipper.trx_dropship_status === 'Selesai' && detailTransaksiDropshipper.trx_shipping.trx_shipping_courier_type !== 'Manual'">
                      <v-btn
                        color="blue-grey"
                        dark
                        :loading="loadingStatus"
                        :class="(isMobile) ? 'v-btn--block' : 'ml-2'"
                        @click="openPrintShippingLabel(item)"
                        v-if="detailTransaksiDropshipper.trx_dropship_status === 'Dikirim'"
                      >
                        <span class="text-subtitle-2 text-capitalize font-weight-bold">Cetak Label Pengiriman</span>
                      </v-btn>
                    </template>

                    <!-- <v-btn
                      outlined
                      dark
                      :loading="loadingStatus"
                      color="green"
                      :class="(isMobile) ? 'v-btn--block mt-5' : 'ml-2'"
                      @click="printInvoice('trx-' + item.trx_dropship_id)"
                      v-if="isMobile && detailTransaksiDropshipper.trx_status != 'Menunggu Pembayaran'"
                    >
                      <span class="text-subtitle-2 text-capitalize font-weight-bold">Invoice</span>
                    </v-btn> -->
                  </v-col>
                </v-row>
              </template>

            </template>
          </td>

          <td :colspan="headers.length" v-else>
            <div class="d-block text-center pa-4 text-caption">loading...</div>
          </td>
        </template>

        <template v-slot:no-data>
          <div class="d-flex flex-column align-center py-5 px-5">
            <v-img width="100" height="100" max-width="100" class="py-5 my-4" src="/assets/seller/belum-ada-pesanan.svg"></v-img>
            <div class="text-subtitle-1 black--text font-weight-bold">Tidak ada data transaksi yang dapat ditampilkan.</div>
          </div>
        </template>
      </v-data-table>
    </v-layout>

    <v-pagination v-if="transaksiDropshipper.pagination.total_page > 1 && transaksiDropshipper.lists.length > 0" @input="updatePage" v-model="page" :length="transaksiDropshipper.pagination.total_page" total-visible="7" circle class="d-flex justify-end no-button-focus py-2"></v-pagination>

    
    <!-- dialog bidding dropshipper -->
    <v-dialog
      v-model="dialogOpenBidding"
      persistent
      scrollable
      max-width="90%"
    >
      <v-card outlined elevation="0" v-if="(Object.keys(this.detailTransaksiDropshipper).length > 0)">
        <v-card-title class="text-h6 text-h6 text-capitalize black--text darken-4">
          Penawaran Komisi Dropshipper
        </v-card-title>
        
        <v-card-text class="py-0 px-5" id="bidHistoryContent">
          <v-row>
            <v-col cols="12" md="8">
              <template v-if="!showBidHistory">
                <template>
                  <v-card outlined elevation="0" class="mb-2">
                    <v-card-subtitle class="font-weight-bold black--text">Data Transaksi Pembeli</v-card-subtitle>
                    <v-card-text class="pb-0 dark--text">
                      <v-row>
                        <v-col cols="12" md="6" class="py-0">
                          <div class="d-flex flex-row mb-50">
                            <label class="mb-0 text-right pa-1" style="width: 45%;">Pembeli :</label>
                            <span class="text-left pa-1 pl-2" style="width: 55%;">{{ detailTransaksiDropshipper.buyer.buyer_name }} <span v-if="detailTransaksiDropshipper.buyer.buyer_city_name != ''">({{ detailTransaksiDropshipper.buyer.buyer_city_name }})</span></span>
                          </div>
                          <div class="d-flex flex-row mb-50">
                            <label class="mb-0 text-right pa-1" style="width: 45%;">Seller :</label>
                            <span class="text-left pa-1 pl-2" style="width: 55%;">{{ detailTransaksiDropshipper.seller.store_name }} <span v-if="detailTransaksiDropshipper.seller.store_city_name != ''">({{ detailTransaksiDropshipper.seller.store_city_name }})</span></span>
                          </div>
                        </v-col>
                        
                        <v-col cols="12" md="6" class="py-0">
                          <div class="d-flex flex-row mb-50">
                            <label class="mb-0 text-right pa-1" style="width: 45%;">No. Transaksi :</label>
                            <span class="text-left pa-1 pl-2" style="width: 55%;">{{ detailTransaksiDropshipper.trx.trx_code }}</span>
                          </div>
                          <div class="d-flex flex-row mb-50">
                            <label class="mb-0 text-right pa-1" style="width: 45%;">Tanggal Transaksi :</label>
                            <span class="text-left pa-1 pl-2" style="width: 55%;">{{ detailTransaksiDropshipper.trx.trx_datetime | tanggaljam }}</span>
                          </div>
                        </v-col>
                      </v-row>
                    </v-card-text>
                    <v-card-text>
                      <v-data-table
                        :headers="headerOrderBuyer"
                        :items="detailOrderBuyer"
                        :items-per-page="15"
                        class="border table-data-order"
                        hide-default-footer
                        no-data-text="data transaksi pembeli belum tersedia"
                      >

                      <template v-slot:item.trx_detail_product_price_margin="{ item }">
                        {{ item.trx_detail_product_price_margin | toNumber }}
                      </template>
                      <template v-slot:item.trx_detail_subtotal_price="{ item }">
                        {{ (parseFloat(item.trx_detail_product_price_margin) * parseFloat(item.trx_detail_quantity)) | toNumber }}
                      </template>
                      
                      <!-- setup additional footer table -->
                      <template slot="body.append">
                        <tr class="footer-row">
                          <th colspan="4" class="text-right text-uppercase">Total Belanja Pembeli</th>
                          <!-- <th class="text-right value">{{ sumField(detailOrderBuyer, 'trx_detail_subtotal_price') | toNumber }}</th> -->
                          <th class="text-right value">{{ detailTransaksiDropshipper.trx.trx_total_margin | toNumber }}</th>
                        </tr>
                        <tr class="footer-row">
                          <th colspan="4" class="text-right text-uppercase">Ongkos Kirim ({{ detailTransaksiDropshipper.trx_shipping.trx_shipping_courier_name }} - {{ detailTransaksiDropshipper.trx_shipping.trx_shipping_courier_service }})</th>
                          <th class="text-right value">{{ detailTransaksiDropshipper.trx_shipping.trx_shipping_courier_total_price | toNumber }}</th>
                        </tr>
                        <tr class="footer-row" v-if="detailTransaksiDropshipper.seller.store_free_delivery == 'Ya'">
                          <th colspan="4" class="text-right text-uppercase">Alokasi Subsidi Ongkos Kirim</th>
                          <!-- <th class="text-right value red--text darken-5">- {{ detailTransaksiDropshipper.trx_shipping.trx_shipping_courier_total_price | toNumber }}</th> -->
                          <th class="text-right value red--text darken-5">- {{ detailTransaksiDropshipper.trx.free_delivery | toNumber }}</th>
                        </tr>
                        <tr class="footer-row" v-if="detailTransaksiDropshipper.trx.discount > 0">
                          <th colspan="4" class="text-right text-uppercase">Diskon Belanja Pembeli</th>
                          <th class="text-right value red--text darken-5">- {{ detailTransaksiDropshipper.trx.discount | toNumber }}</th>
                        </tr>
                        <tr class="footer-row">
                          <th colspan="4" class="text-right text-uppercase">Biaya Layanan</th>
                          <th class="text-right value">{{ detailTransaksiDropshipper.trx.trx_service_fee | toNumber }}</th>
                        </tr>
                        <tr class="footer-row" v-if="detailTransaksiDropshipper.seller.store_free_delivery == 'Ya'">
                          <th colspan="4" class="text-right text-uppercase">Ongkir Ditanggung {{ (detailTransaksiDropshipper.seller.store_free_delivery == 'Ya') ? 'Dropshipper' : 'Pembeli' }}</th>
                          <th class="text-right value" :class="(detailTransaksiDropshipper.trx.discount > 0) ? '' : 'orange--text'">{{ (detailTransaksiDropshipper.trx.discount > 0) ? 0 : (detailTransaksiDropshipper.trx_shipping.trx_shipping_courier_total_price - detailTransaksiDropshipper.trx.free_delivery) | toNumber }}</th>
                        </tr>
                        <tr class="footer-row">
                          <th colspan="4" class="text-right text-uppercase">Grand Total Belanja</th>
                          <th class="text-right value">{{ detailTransaksiDropshipper.trx.trx_grand_total | toNumber }}</th>
                        </tr>
                      </template>
                      <!-- end additional footer table -->
                      </v-data-table>
                    </v-card-text>
                  </v-card>
                </template>

                <template>
                  <v-card outlined elevation="0" class="mb-2">
                    <v-card-subtitle class="font-weight-bold black--text">Data Transaksi Dropship</v-card-subtitle>
                    <v-card-text class="pb-0 dark--text">
                      <v-row>
                        <v-col cols="12" md="6" class="py-0">
                          <div class="d-flex flex-row mb-50">
                            <label class="mb-0 text-right pa-1" style="width: 45%;">Dropshipper :</label>
                            <span class="text-left pa-1 pl-2" style="width: 55%;">{{ detailTransaksiDropshipper.seller.store_name }} <span v-if="detailTransaksiDropshipper.seller.store_city_name != ''">({{ detailTransaksiDropshipper.seller.store_city_name }})</span></span>
                          </div>
                          <div class="d-flex flex-row mb-50">
                            <label class="mb-0 text-right pa-1" style="width: 45%;">Stockist Dropship :</label>
                            <span class="text-left pa-1 pl-2 text-wrap" style="width: 55%;">{{ detailTransaksiDropshipper.dropship.store_name }} <span v-if="detailTransaksiDropshipper.dropship.store_city_name != ''">({{ detailTransaksiDropshipper.dropship.store_city_name }})</span></span>
                          </div>
                        </v-col>
                        
                        <v-col cols="12" md="6" class="py-0">
                          <div class="d-flex flex-row mb-50">
                            <label class="mb-0 text-right pa-1" style="width: 45%;">No. Transaksi :</label>
                            <span class="text-left pa-1 pl-2" style="width: 55%;">{{ detailTransaksiDropshipper.trx_dropship_code }}</span>
                          </div>
                          <div class="d-flex flex-row mb-50">
                            <label class="mb-0 text-right pa-1" style="width: 45%;">Tanggal Transaksi :</label>
                            <span class="text-left pa-1 pl-2" style="width: 55%;">{{ detailTransaksiDropshipper.trx_dropship_datetime | tanggaljam }}</span>
                          </div>
                        </v-col>
                      </v-row>
                    </v-card-text>
                    <v-card-text>
                      <v-data-table
                        :headers="headerOrderDropship"
                        :items="detailOrderDropship"
                        :items-per-page="15"
                        class="border table-data-order"
                        hide-default-footer
                        no-data-text="data transaksi dropship belum tersedia"
                      >
                        <template v-slot:item.trx_dropship_detail_product_price="{ item }">
                          {{ item.trx_dropship_detail_product_price | toNumber }}
                        </template>
                        <template v-slot:item.trx_dropship_detail_subtotal_price="{ item }">
                          {{ item.trx_dropship_detail_subtotal_price | toNumber }}
                        </template>

                        <!-- setup additional footer table -->
                        <template slot="body.append">
                          <tr class="footer-row">
                            <th colspan="4" class="text-right text-uppercase">Total Belanja Dropship</th>
                            <th class="text-right value">{{ detailTransaksiDropshipper.trx_dropship_subtotal_price | toNumber }}</th>
                          </tr>
                          <tr class="footer-row">
                            <th colspan="4" class="text-right text-uppercase">Ongkos Kirim ({{ detailTransaksiDropshipper.trx_dropship_shipping.trx_dropship_shipping_courier_name }} - {{ detailTransaksiDropshipper.trx_dropship_shipping.trx_dropship_shipping_courier_service }})</th>
                            <th class="text-right value">{{ detailTransaksiDropshipper.trx_dropship_shipping.trx_dropship_shipping_courier_total_price | toNumber }}</th>
                          </tr>
                        </template>
                        <!-- end additional footer table -->
                      </v-data-table>
                    </v-card-text>
                  </v-card>
                </template>
              </template>

              <template v-else>
                <v-card outlined elevation="0" class="mb-2">
                  <v-card-subtitle class="font-weight-bold black--text">Riwayat Komisi Penawaran</v-card-subtitle>
                  <v-card-text class="pb-0 dark--text">
                    <v-data-table
                      :headers="headerBidHistory"
                      :items="bidHistory"
                      :items-per-page="15"
                      class="border table-data-order font-size-12 mb-5"
                      no-data-text="data penawaran komisi dropshipper belum tersedia"
                    >
                      <template v-slot:item.trx_dropship_profit_sharing_status_datetime="{ item }">
                        {{ item.trx_dropship_profit_sharing_status_datetime | tanggaljam }}
                      </template>
                      <template v-slot:item.trx_dropship_profit_sharing_status="{ item }">
                        <v-chip
                        label
                        small
                        pill
                        class="font-weight-bold"
                        :class="colorStatus(item.trx_dropship_profit_sharing_status)"
                        >
                          {{ item.trx_dropship_profit_sharing_status }}
                        </v-chip>
                      </template>
                      <template v-slot:item.trx_dropship_profit_sharing_trx_nett_price="{ item }">
                        {{ item.trx_dropship_profit_sharing_trx_nett_price | toNumber }}
                      </template>
                      <template v-slot:item.trx_dropship_profit_sharing_claim_dropship_value="{ item }">
                        {{ item.trx_dropship_profit_sharing_claim_dropship_value | toNumber }}
                      </template>
                      <template v-slot:item.trx_dropship_profit_sharing_trx_shipping_cost="{ item }">
                        {{ item.trx_dropship_profit_sharing_trx_shipping_cost | toNumber }}
                      </template>
                      <template v-slot:item.trx_dropship_profit_sharing_claim_dropshipper_value="{ item }">
                        {{ item.trx_dropship_profit_sharing_claim_dropshipper_value | toNumber }}
                        <!-- {{ (parseFloat(item.trx_dropship_profit_sharing_trx_grand_total) - parseFloat(item.trx_dropship_profit_sharing_claim_dropshipper_value)) | toNumber }} -->
                      </template>
                    </v-data-table>
                  </v-card-text>
                </v-card>
              </template>
            </v-col>

            <v-col cols="12" md="4">
              <v-card outlined elevation="0">
                <v-card-subtitle class="font-weight-bold black--text">Estimasi Komisi Transaksi</v-card-subtitle>
                <v-card-text>
                  <label class="d-block font-weight-bold">Komisi Dropshipper</label><hr class="mt-2 mb-4">
                  <template v-if="Object.keys(latestKlaim).length > 0">
                    <div class="d-flex flex-column mb-50 font-size-11">
                      <label class="mb-0 text-left pa-1" style="width: 100%;">Status Penawaran Terakhir</label>
                      <!-- <label class="mb-0 text-center pa-1" style="width: 5%;">:</label> -->
                      <span class="d-block text-center dark--text font-weight-bold pa-1 pl-0 mb-2" style="width:100%;">
                        <v-chip
                          label
                          small
                          pill
                          class="d-block font-weight-bold"
                          :class="colorStatus(latestKlaim.trx_dropship_profit_sharing_status)"
                          >
                            {{ latestKlaim.trx_dropship_profit_sharing_status }}
                          </v-chip>
                      </span>
                    </div>
                    <hr>
                  </template>

                  <div class="d-flex flex-row mb-50 font-size-11">
                    <label class="mb-0 text-left pa-1" style="width: 50%;">Total Belanja Pembeli</label>
                    <label class="mb-0 text-center pa-1" style="width: 5%;">:</label>
                    <span class="text-right dark--text font-weight-bold pa-1 pl-2" style="width: 45%;">{{ detailTransaksiDropshipper.trx.trx_total_margin | toNumber }}</span>
                  </div>
                  <div class="d-flex flex-row mb-50 font-size-11" v-if="detailTransaksiDropshipper.seller.store_free_delivery == 'Ya'">
                    <label class="mb-0 text-left pa-1" style="width: 50%;">Subsidi Ongkir</label>
                    <label class="mb-0 text-center pa-1" style="width: 5%;">:</label>
                    <span class="text-right dark--text font-weight-bold pa-1 pl-2" style="width: 45%;">{{ detailTransaksiDropshipper.trx.free_delivery | toNumber }}</span>
                  </div>
                  <div class="d-flex flex-row mb-50 font-size-11" v-if="detailTransaksiDropshipper.trx.discount > 0">
                    <label class="mb-0 text-left pa-1" style="width: 50%;">Diskon Belanja Pembeli</label>
                    <label class="mb-0 text-center pa-1" style="width: 5%;">:</label>
                    <span class="text-right dark--text font-weight-bold pa-1 pl-2" style="width: 45%;">{{ detailTransaksiDropshipper.trx.discount | toNumber }}</span>
                  </div>
                  <div class="d-flex flex-row mb-50 font-size-11">
                    <label class="mb-0 text-left pa-1" style="width: 50%;">Total Belanja Dropship</label>
                    <label class="mb-0 text-center pa-1" style="width: 5%;">:</label>
                    <span class="text-right dark--text font-weight-bold pa-1 pl-2" style="width: 45%;">{{ detailTransaksiDropshipper.trx_dropship_subtotal_price | toNumber }}</span>
                  </div>
                  <hr class="my-2">
                  <div class="d-flex flex-row mb-50 font-size-11">
                    <label class="mb-0 text-left pa-1 font-weight-bold black--text" style="width: 50%;">Margin Produk</label>
                    <label class="mb-0 text-center pa-1 font-weight-bold black--text" style="width: 5%;">:</label>
                    <span class="text-right black--text font-weight-bold pa-1 pl-2" style="width: 45%;">{{ (detailTransaksiDropshipper.trx.trx_total_margin - detailTransaksiDropshipper.trx.free_delivery - detailTransaksiDropshipper.trx_dropship_subtotal_price - detailTransaksiDropshipper.trx.discount) | toNumber }}</span>
                  </div>
                  <div class="d-flex flex-row mb-50 font-size-11" v-if="detailTransaksiDropshipper.seller.store_free_delivery == 'Ya'">
                    <label class="mb-0 text-left pa-1" style="width: 50%;">Ongkir Ditanggung {{ (detailTransaksiDropshipper.seller.store_free_delivery == 'Ya') ? 'Dropshipper' : 'Pembeli' }}</label>
                    <label class="mb-0 text-center pa-1" style="width: 5%;">:</label>
                    <span class="text-right dark--text font-weight-bold pa-1 pl-2" style="width: 45%;">{{ (detailTransaksiDropshipper.trx.discount > 0) ? 0 : (detailTransaksiDropshipper.trx_shipping.trx_shipping_courier_total_price - detailTransaksiDropshipper.trx.free_delivery) | toNumber }}</span>
                  </div>
                  <div class="d-flex flex-row mb-50 font-size-11">
                    <label class="mb-0 text-left pa-1" style="width: 50%;">Selisih Ongkir</label>
                    <label class="mb-0 text-center pa-1" style="width: 5%;">:</label>
                    <span class="text-right dark--text font-weight-bold pa-1 pl-2" style="width: 45%;">{{ parseFloat((detailTransaksiDropshipper.trx_shipping.trx_shipping_courier_total_price - detailTransaksiDropshipper.trx_dropship_shipping.trx_dropship_shipping_courier_total_price)) | toNumber }}</span>
                  </div>
                  <hr class="my-2">
                  <div class="d-flex flex-row mb-50 font-size-12">
                    <label class="mb-0 text-left pa-1 font-weight-bold black--text text-uppercase" style="width: 50%;">Total Komisi Dropshipper</label>
                    <label class="mb-0 text-center pa-1 font-weight-bold black--text" style="width: 5%;">:</label>
                    <span class="text-right dark--text font-weight-bold pa-1 pl-2" style="width: 45%;" v-if="detailTransaksiDropshipper.seller.store_free_delivery == 'Ya'">
                      {{ ((detailTransaksiDropshipper.trx.trx_total_margin - detailTransaksiDropshipper.trx.free_delivery - detailTransaksiDropshipper.trx_dropship_subtotal_price - detailTransaksiDropshipper.trx.discount) - ((detailTransaksiDropshipper.trx.discount > 0) ? 0 : (detailTransaksiDropshipper.trx_shipping.trx_shipping_courier_total_price - detailTransaksiDropshipper.trx.free_delivery)) + parseFloat((detailTransaksiDropshipper.trx_shipping.trx_shipping_courier_total_price - detailTransaksiDropshipper.trx_dropship_shipping.trx_dropship_shipping_courier_total_price))) | toNumber }}
                    </span>
                    <span class="text-right dark--text font-weight-bold pa-1 pl-2" style="width: 45%;" v-else>
                      {{ ((detailTransaksiDropshipper.trx.trx_total_margin - detailTransaksiDropshipper.trx.free_delivery - detailTransaksiDropshipper.trx_dropship_subtotal_price - detailTransaksiDropshipper.trx.discount) + parseFloat((detailTransaksiDropshipper.trx_shipping.trx_shipping_courier_total_price - detailTransaksiDropshipper.trx_dropship_shipping.trx_dropship_shipping_courier_total_price))) | toNumber }}
                    </span>

                  </div>
                </v-card-text>

                <v-card-text>
                  <label class="d-block font-weight-bold">Klaim Anda</label><hr class="mt-2 mb-4">
                  <div class="d-flex flex-row mb-50 font-size-11">
                    <label class="mb-0 text-left pa-1" style="width: 50%;">Harga Produk</label>
                    <label class="mb-0 text-center pa-1" style="width: 5%;">:</label>
                    <span class="text-right dark--text font-weight-bold pa-1 pl-2" style="width: 45%;">{{ detailTransaksiDropshipper.trx_dropship_subtotal_price | toNumber }}</span>
                  </div>
                  <!-- <div class="d-flex flex-row mb-50 font-size-11" v-if="detailTransaksiDropshipper.seller.store_free_delivery == 'Ya'">
                    <label class="mb-0 text-left pa-1" style="width: 50%;">Penggantian Ongkos Kirim</label>
                    <label class="mb-0 text-center pa-1" style="width: 5%;">:</label>
                    <span class="text-right dark--text font-weight-bold pa-1 pl-2" style="width: 45%;">{{ detailTransaksiDropshipper.trx_dropship_shipping.trx_dropship_shipping_courier_total_price | toNumber }}</span>
                  </div> -->
                  <!-- <div class="d-flex flex-row mb-50 font-size-11">
                    <label class="mb-0 text-left pa-1" style="width: 50%;">Penggantian Ongkos Kirim</label>
                    <label class="mb-0 text-center pa-1" style="width: 5%;">:</label>
                    <span class="text-right dark--text font-weight-bold pa-1 pl-2" style="width: 45%;">{{ detailTransaksiDropshipper.trx_dropship_shipping.trx_dropship_shipping_courier_total_price | toNumber }}</span>
                  </div> -->

                  <hr class="my-2">
                  <div class="d-flex flex-row mb-50 font-size-12">
                    <label class="mb-0 text-left pa-1 font-weight-bold black--text text-uppercase" style="width: 50%;">Total</label>
                    <label class="mb-0 text-center pa-1 font-weight-bold black--text" style="width: 5%;">:</label>
                    <span class="text-right dark--text font-weight-bold pa-1 pl-2" style="width: 45%;">{{ (parseFloat(detailTransaksiDropshipper.trx_dropship_subtotal_price)) | toNumber }}</span>
                    <!-- <span class="text-right dark--text font-weight-bold pa-1 pl-2" style="width: 45%;" v-if="detailTransaksiDropshipper.seller.store_free_delivery == 'Ya'">{{ (parseFloat(detailTransaksiDropshipper.trx_dropship_subtotal_price) + parseFloat(detailTransaksiDropshipper.trx_dropship_shipping.trx_dropship_shipping_courier_total_price)) | toNumber }}</span>
                    <span class="text-right dark--text font-weight-bold pa-1 pl-2" style="width: 45%;" v-else>{{ (parseFloat(detailTransaksiDropshipper.trx_dropship_subtotal_price)) | toNumber }}</span> -->
                  </div>
                </v-card-text>

                <v-card-text v-if="latestKlaim.trx_dropship_profit_sharing_status == 'Disetujui'">
                  <label class="d-block font-weight-bold">Klaim Anda</label><hr class="mt-2 mb-4">
                  <div class="d-flex flex-row mb-50 font-size-11">
                    <label class="mb-0 text-left pa-1" style="width: 50%;">Komisi Dropshipper</label>
                    <label class="mb-0 text-center pa-1" style="width: 5%;">:</label>
                    <span class="text-right primary--text font-weight-bold pa-1 pl-2" style="width: 45%;">{{ parseFloat(latestKlaim.trx_dropship_profit_sharing_claim_dropshipper_value) | toNumber }}</span>
                  </div>
                  <div class="d-flex flex-row mb-50 font-size-11">
                    <label class="mb-0 text-left pa-1" style="width: 50%;">Klaim Anda</label>
                    <label class="mb-0 text-center pa-1" style="width: 5%;">:</label>
                    <span class="text-right primary--text font-weight-bold pa-1 pl-2" style="width: 45%;">{{ latestKlaim.trx_dropship_profit_sharing_claim_dropship_value | toNumber }}</span>
                  </div>
                </v-card-text>

                <v-card-text v-else>
                  <label class="d-block font-weight-bold primary--text text-uppercase">Penawaran Komisi Dropshipper</label><hr class="mt-2 mb-4">
                  <v-form ref="formKomisi" role="form">
                    <div class="d-flex flex-row align-center mb-50 font-size-11">
                      <label class="mb-0 text-left pa-1 black--text text-uppercase" style="width: 40%;">Komisi Dropshipper</label>
                      <div class="text-right dark--text pa-1 pl-2" style="width: 60%;">
                        <v-currency-field
                          v-model="klaim.setKomisiDropshipper"
                          outlined
                          small
                          dense
                          placeholder="Masukkan penawaran"
                          prefix=""
                          disabled
                          hide-details="auto"
                          persistent-hint
                          class="small-input-text curr-input-text font-weight-bold"
                          :rules="rulesKomisi.klaimDropshipper"
                          :error-messages="komisiError.klaimDropshipper"
                        ></v-currency-field>
                          <!-- @input="inputDropshipShare()" -->
                          <!-- v-model="produkInput.hargaSatuan"
                          :rules="priceRules" -->
                          <!-- :error-messages="responseError.price"
                          @focus="() => responseError.price=''" -->
                      </div>
                    </div>
                    <div class="d-flex flex-row align-center mb-50 font-size-11">
                      <label class="mb-0 text-left pa-1  black--text text-uppercase" style="width: 40%;">Klaim Anda</label>
                      <div class="text-right dark--text pa-1 pl-2" style="width: 60%;">
                        <v-currency-field
                          v-model="klaim.setKlaimValue"
                          outlined
                          small
                          dense
                          placeholder="Masukkan nilai klaim"
                          prefix=""
                          hide-details="auto"
                          persistent-hint
                          class="small-input-text curr-input-text font-weight-bold"
                          @input="inputClaimShare()"
                          :rules="rulesKomisi.klaimDropship"
                          :error-messages="komisiError.klaimDropship"
                        ></v-currency-field>
                          <!-- v-model="produkInput.hargaSatuan"
                          :rules="priceRules" -->
                          <!-- :error-messages="responseError.price"
                          @focus="() => responseError.price=''" -->
                      </div>
                    </div>
                    <div class="d-flex flex-row align-center mb-50 font-size-11">
                      <label class="mb-0 text-left pa-1  black--text text-uppercase" style="width: 40%;">Upload Foto</label>
                      <div class="text-right dark--text font-weight-bold pa-1 pl-2" style="width: 60%;">
                        <v-btn
                          block
                          outlined
                          color="primary"
                          @click="openUpload"
                        ><v-icon dense class="mr-1">mdi-upload</v-icon> <span v-if="imagePV">Unggah Ulang</span><span v-else>Unggah</span></v-btn>
                        <v-file-input @change="handleFileUpload" v-show="false" accept="image/*" id="inputImage" truncate-length="50"></v-file-input>
                        <!-- :rules="rulesKomisi.pvImage" -->
                        
                      </div>
                    </div>
                    <div class="d-flex flex-column align-center justify-center mb-50 font-size-11">
                      <div class="d-block border border-lg my-4 pa-2" v-if="imagePV" style="width: 100%;">
                        <v-img width="60%" class="border d-block mx-auto" :src="imagePV"></v-img>
                      </div>
                      <template v-if="komisiError.pvImage !== ''">
                        <div class="text-caption red--text d-block pa-1 my-1" style="background: #fcdbe1;width: 100%;" v-if="!imagePV">
                          {{ komisiError.pvImage }}
                        </div>
                      </template>
                      <div class="text-caption">
                        <small>Format gambar .jpg .jpeg .png dan ukuran minimum 500 x 500 px (Untuk gambar optimal gunakan minimum 700 x 700 px)</small>
                      </div>
                    </div>
                  </v-form>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions class="px-8">
          <v-row class="text-right d-flex justify-space-between">
            <v-btn
              outlined
              :color="(!showBidHistory) ? 'primary' : 'grey'"
              :loading="loadingBidding"
              @click="openBidHistory()"
              class="my-2 px-5 mx-1 text-capitalize"
            >
              {{ (!showBidHistory) ? 'Riwayat Penawaran Komisi' : 'Tutup Riwayat Penawaran Komisi' }}
            </v-btn>

            <div class="d-block">
              <v-btn
                outlined
                :loading="loadingBidding"
                @click="resetBidding()"
                class="my-2 px-5 mx-1 text-capitalize"
              >
                {{ (latestKlaim.trx_dropship_profit_sharing_status == 'Disetujui' || latestKlaim.trx_dropship_profit_sharing_status == 'Menunggu Persetujuan') ? 'Tutup' : 'Batal' }}
              </v-btn>
              <v-btn
                :loading="loadingBidding"
                color="primary"
                @click="submitRequestBid()"
                class="my-2 px-5 mx-1 text-capitalize"
                :disabled="(latestKlaim.trx_dropship_profit_sharing_status == 'Disetujui' || latestKlaim.trx_dropship_profit_sharing_status == 'Menunggu Persetujuan') ? true : false"
              >
                Submit Penawaran
              </v-btn>
            </div>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    
    <!-- dialog konfirm pesanan -->
    <v-dialog
      v-model="dialogStatusPesanan"
      persistent
      max-width="600"
    >
      <v-card>
        <v-card-title class="text-h6 text-h6 text-capitalize black--text darken-4">
          <v-img width="25" max-width="25" class="mr-2" src="/assets/seller/status-pesanan-no-padding.svg"></v-img> Status Pesanan
        </v-card-title>
        <v-card-text class="py-0 px-5">
          <template v-if="(Object.keys(detailTransaksiDropshipper).length > 0)">
            <v-row class="px-5 py-3 align-center">
              <v-col cols="12" sm="6">
                <div class="d-block text-subtitle-1 font-weight-bold black--text">{{ detailTransaksiDropshipper.trx_code }}</div>
                <div class="text-subtitle-2">{{ formatDateText(detailTransaksiDropshipper.trx_datetime, 'DD MMMM YYYY HH:mm') }}</div>
              </v-col>

              <v-col cols="12" sm="6" :class="(isMobile) ? 'text-left pt-0' : 'text-right'">
                <v-chip
                  label
                  class="font-weight-bold"
                  :class="colorStatus(detailTransaksiDropshipper.trx_dropship_status)"
                >{{ detailTransaksiDropshipper.trx_dropship_status }}</v-chip>
              </v-col>
            </v-row>
            <v-spacer></v-spacer>
            <hr>

            <div class="d-block py-5">
              <!-- <v-timeline
                align-top
                dense
                v-if="historyStatus"
              >
                <template v-for="(log, idl) in historyStatus">
                  <v-timeline-item
                    :color="(log.trx_status === detailTransaksiDropshipper.trx_status) ? 'green' : 'grey darken-5'"
                    small
                    :key="idl"
                    v-if="log.trx_status_datetime"
                  >
                    <v-row class="py-0">
                      <v-col cols="12" sm="4" class="py-0">
                        <span class="grey--text">{{ formatDateText(log.trx_status_datetime, 'DD MMMM YYYY HH:mm') }}</span>
                      </v-col>
                      <v-col class="py-0">
                        <div class="d-block font-weight-bold black--text" :class="{'text-subtitle-2': isMobile}">
                          {{ log.trx_status_desc }}
                        </div>
                      </v-col>
                    </v-row>
                  </v-timeline-item>
                </template>
              </v-timeline> -->
            </div>
          </template>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-row class="text-center">
            <hr>
            <v-btn
              outlined
              @click="dialogStatusPesanan = false, selectedItem = null"
              class="my-2 px-5 text-capitalize"
            >
              Tutup
            </v-btn>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- dialog lacak -->
    <v-dialog
      v-model="dialogLacak"
      persistent
      scrollable
      max-width="600"
    >
      <v-card>
        <v-card-title class="text-h6 text-h6 text-capitalize black--text darken-4">
          Lacak Pengiriman
        </v-card-title>
        <v-card-text class="py-0 px-5">
          <v-row class="pa-5 align-center" v-if="(Object.keys(detailTransaksiDropshipper).length > 0)">
            <v-col cols="3">
              <v-img contain width="100%" max-width="100%" class="mr-4" :src="(detailTransaksiDropshipper.trx_dropship_shipping.trx_dropship_shipping_courier_logo_url !== '') ? detailTransaksiDropshipper.trx_dropship_shipping.trx_dropship_shipping_courier_logo_url : '/assets/product/default.png'"></v-img>
            </v-col>

            <v-col cols="9">
              <!-- <pre>{{ trackingDropshipTrx }}</pre> -->
              <div class="d-block text-subtitle-1 font-weight-bold black--text">{{ detailTransaksiDropshipper.trx_dropship_shipping.trx_dropship_shipping_courier_awb_number }}</div>
              <div class="text-subtitle-2">{{ (detailTransaksiDropshipper.trx_dropship_shipping.trx_dropship_shipping_courier_name) ? detailTransaksiDropshipper.trx_dropship_shipping.trx_dropship_shipping_courier_name.toUpperCase() : '' }} {{ detailTransaksiDropshipper.trx_dropship_shipping.trx_dropship_shipping_courier_service }}</div>
            </v-col>
          </v-row>
          <v-spacer></v-spacer>
          <hr>

          <div class="d-block py-5">
            <!-- <div class="d-block pa-4 mb-5 grey lighten-2 font-weight-bold black--text text-center">
              Menunggu Status Resi
            </div> -->

            <!-- jika belum ada update -->
            <div class="d-flex flex-column align-center">
              <div class="d-block pa-2 text-center">
                <div class="text-subtitle-2">Belum ada update pengiriman dari kurir. Silakan lacak kembali secara berkala maksimal 3 x 24 jam.</div>
              </div>
            </div>

            <div class="d-flex flex-column align-center">

              <template v-if="Object.keys(trackingDropshipTrx).length > 0 && trackingDropshipTrx.tracking_history.length > 0">
                <div class="d-block pa-3 text-center" v-for="(log, idl) in trackingDropshipTrx.tracking_history" :key="idl">
                  <div class="d-block text-subtitle-2 font-weight-bold black--text text-capitalize">{{ log.description }}</div>
                  <div class="text-subtitle-2">{{ log.date | tanggaljam }}</div>
                </div>
                <div class="v-spacer"></div>
              </template>

              <template v-else>
                <div class="d-flex flex-column align-center py-5 px-5">
                  <v-img width="160" class="py-3 my-3" src="/assets/seller/no-data.svg"></v-img>
                  <div class="text-h7 darkred--text text-center">Belum ada informasi tracking pesanan<br>yang dapat ditampilkan.</div>
                </div>
              </template>

            </div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-row class="text-center">
            <hr>
            <v-btn
              outlined
              @click="dialogLacak = false"
              class="my-2 px-5 text-capitalize"
            >
              Tutup
            </v-btn>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- dialog seller note -->
    <v-dialog
      v-model="dialogSellerNotes"
      persistent
      max-width="600"
    >
      <v-card>
        <v-card-title class="text-h6 text-h6 text-capitalize black--text darken-4">
          Tambah Catatan
        </v-card-title>
        <v-card-text class="pt-3 pb-0 px-5">
          <v-textarea
            v-model="courier_note"
            outlined
            counter="200"
            maxlength="200"
            name="input-7-4"
            label="Catatan Penjual"
            @blur="detailTransaksiDropshipper.trx_dropship_shipping.trx_dropship_shipping_courier_note = courier_note"
          ></v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-row class="text-center">
            <hr>
            <v-btn
              outlined
              @click="dialogSellerNotes = false"
              class="my-2 px-5 text-capitalize"
            >
              Tutup
            </v-btn>
            <v-btn
              color="green"
              @click="dialogSellerNotes = false"
              class="my-2 px-5 ml-2 text-capitalize white--text"
            >
              Simpan
            </v-btn>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- dialog cancel order -->
    <v-dialog
      v-model="dialogCancelOrder"
      persistent
      max-width="600"
    >
      <v-card>
        <v-card-title class="text-h6 text-h6 text-capitalize black--text darken-4">
          Pembatalan Pesanan
        </v-card-title>
        <v-card-text class="pt-2 pb-0 px-5 mx-1">
          <div class="d-block font-weight-bold text-subtitle-1 black--text">Alasan Pembatalan :</div>
          <div class="cancelOption">
            <v-radio-group row>
              <v-radio
                v-for="n in pembatalanOpt"
                :key="n.id"
                :value="n.id"
              >
                <template v-slot:label>
                  <v-alert
                    text
                    dense
                    outlined
                    small
                    :color="(n.id === pesanan[0].alasanPembatalan) ? 'red' : 'grey'"
                    class="mb-3"
                  >
                    {{ n.label }}
                  </v-alert>
                </template>
              </v-radio>
            </v-radio-group>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-row class="text-center">
            <hr>
            <v-btn
              outlined
              @click="dialogCancelOrder = false"
              class="my-2 px-5 text-capitalize"
            >
              Tutup
            </v-btn>
            <v-btn
              color="red"
              @click="dialogCancelOrder = false"
              class="my-2 px-5 ml-2 text-capitalize white--text"
            >
              Batalkan
            </v-btn>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- dialog confirm approve order -->
    <v-dialog
      v-model="dialogConfirmTerimaorder"
      persistent
      max-width="500"
    >
      <v-card>
        <v-card-title class="text-h6 text-h6 text-capitalize green--text">
          <span v-if="allowChangeResi == false">Konfirmasi Terima Pesanan</span>
          <span v-else>Konfirmasi Ubah Resi</span>
        </v-card-title>
        <v-card-text class="pt-2 pb-0 px-5 mx-1 text-center">
          <v-row>
            <v-col cols="12">
              <div v-if="allowChangeResi == false" class="text-subtitle-1 mb-3">Apakah pesanan <strong class="green--text">{{ (selectedItem) ? selectedItem.trx_dropship_code : '' }}</strong> akan diproses ?</div>
              <div v-else class="text-subtitle-1 mb-3">Apakah Anda yakin mengubah resi pesanan <strong class="green--text">{{ (selectedItem) ? selectedItem.trx_dropship_code : '' }}</strong>?</div>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="mt-5">
          <v-spacer></v-spacer>
          <v-row class="text-center">
            <hr>
            <v-btn
              outlined
              class="my-2 px-5 text-capitalize"
              :loading="loadingStatus"
              @click="dialogConfirmTerimaorder = false, selectedItem = null"
            >
              Tidak
            </v-btn>
            <v-btn
              v-if="allowChangeResi == false"
              color="green"
              :loading="loadingStatus"
              class="my-2 px-5 ml-2 text-capitalize white--text"
              @click="prosesPesananAct(selectedItem.trx_dropship_id)"
            >
              Proses
            </v-btn>
            <v-btn
              v-else
              color="green"
              :loading="loadingStatus"
              class="my-2 px-5 ml-2 text-capitalize white--text"
              @click="ubahResi(selectedItem.trx_dropship_id)"
            >
              Proses
            </v-btn>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- dialog konfirm kirim -->
    <v-dialog
      v-model="dialogConfirmKirim"
      persistent
      max-width="500"
    >
      <v-card>
        <v-card-title class="text-h6 text-h6 text-capitalize green--text">
          Konfirmasi Pengiriman Pesanan
        </v-card-title>
        <v-card-text class="pt-2 pb-0 px-5 mx-1 text-center">
          <v-row>
            <v-col cols="12">
              <div class="text-subtitle-1 mb-3">Apakah pesanan <strong class="green--text">{{ (selectedItem) ? selectedItem.trx_dropship_code : '' }}</strong> akan diproses ke pengiriman ?</div>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="mt-5">
          <v-spacer></v-spacer>
          <v-row class="text-center">
            <hr>
            <v-btn
              outlined
              class="my-2 px-5 text-capitalize"
              :loading="loadingStatus"
              @click="dialogConfirmKirim = false, selectedItem = null"
            >
              Batal
            </v-btn>
            <v-btn
              color="green"
              :loading="loadingStatus"
              class="my-2 px-5 ml-2 text-capitalize white--text"
              @click="kirimPesananAct(selectedItem.trx_dropship_id)"
            >
              Kirim
            </v-btn>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- change seller -->
    <v-dialog
      v-model="dialogConfirmChangeStokis"
      persistent
    >
      <!-- max-width="800" -->
      <v-card>
        <v-card-title class="text-h6 text-h6 text-capitalize primary--text">
          Ubah Stokis
        </v-card-title>
        
        <v-card-text class="pt-0 pb-0 px-5 mx-1">
          <v-row>
            <v-col cols="12">
              <v-form ref="formAddProduct" role="form">
                <v-card outlined class="pa-1">
                  <v-card-text class="px-2">
                    <v-row>
                      <v-col cols="12" sm="6" class="py-0">
                        <v-text-field
                          v-model="produkInput.nama"
                          outlined
                          hide-details="auto"
                          small
                          dense
                          placeholder="Masukkan nama stokis"
                          :error-messages="responseError.name"
                          @focus="() => responseError.name=''"
                        ></v-text-field>
                      </v-col>

                      <v-col cols="12" sm="2" class="py-0"></v-col>

                      <v-col cols="12" sm="4" class="py-0">
                        <v-autocomplete
                          v-model="produkInput.unit"
                          :items="['Ketersediaan produk', 'Stokis terdekat saya', 'Stokis terdekat pembeli']"
                          placeholder="tampilkan berdasarkan"
                          hide-details="auto"
                          outlined
                          dense
                        ></v-autocomplete>
                          <!-- :error-messages="responseError.unit" -->
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>

                <v-row class="my-3">
                  <v-col cols="12" sm="12" md="3">
                    <v-card outlined class="px-3 pb-3">
                      <v-card-title class="pb-0 px-2 text-subtitle-1 font-weight-bold black--text darken-4">
                        Info Produk
                      </v-card-title>
                      <v-row class="mb-1">
                        <v-col cols="12" sm="12" class="text-left" :class="{'pb-0': isMobile}">
                          <template v-for="(produk, idp) in detailTransaksiDropshipper.trx_detail">
                            <div :key="idp" class="d-flex flex-column align-start" :class="(isMobile) ? 'mb-0' : 'mb-0'">
                              <v-img width="80" max-width="80" class="mr-4" :src="(produk.trx_detail_product_image) ? produk.trx_detail_product_image : '/assets/product/default.png'"></v-img>
                              <div class="d-block mt-2 w-full">
                                <v-row class="flex-column w-full mx-auto">
                                  <v-col col="12" class="d-flex justify-space-between w-full pb-0">
                                    <label>Nama Produk</label>
                                    <span class="d-block font-weight-bold">{{ produk.trx_detail_product_name }}</span>
                                  </v-col>
                                  <v-col col="12" class="d-flex justify-space-between w-full pb-0">
                                    <label>Qty</label>
                                    <span class="d-block font-weight-bold">{{ produk.trx_detail_quantity }}</span>
                                  </v-col>
                                  <v-col col="12" class="d-flex justify-space-between w-full pb-0">
                                    <label>Harga Produk</label>
                                    <span class="d-block font-weight-bold">{{ (produk.trx_detail_product_price) | toRupiah }}</span>
                                  </v-col>
                                </v-row>
                                <!-- <div class="font-weight-bold no-line green--text">HWI-C</div>
                                <div class="text-caption">{{ produk.trx_detail_quantity }} barang ({{ produk.trx_detail_product_weight | toKg }}) @ {{ (produk.trx_detail_product_price) | toRupiah }} </div>
                                <div class="text-caption">Subtotal : <strong>{{ (produk.trx_detail_product_price * produk.trx_detail_quantity) | toRupiah }}</strong></div> -->
                              </div>
                            </div>
                          </template>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>

                  <v-col cols="12" sm="12" md="9">
                    <v-card outlined class="px-3">
                      <v-card-title class="pb-0 px-2 text-subtitle-1 font-weight-bold black--text darken-4">
                        Daftar Stokis
                      </v-card-title>
                      <v-card-text class="px-2 py-0 pb-0">
                        <template v-if="listStokis.length > 0">
                          <v-radio-group class="mt-0 pt-2" v-model="checkedMethod">
                            <v-row class="justify-start align-center">
                              <v-col cols="12" sm="6" md="4" lg="4" class="" v-for="(gudang, id) in listStokis" :key="id">
                                <v-card outlined class="px-3 py-2 hwi-border elevation-0 rounded hover-shadow" @click="checkMethod(gudang.id)">
                                  <v-row class="align-start">
                                    <v-col cols="2" sm="2" md="2" class="pl-5 d-flex justify-center align-start">
                                      <v-radio color="primary" large on-icon="mdi-check-circle" off-icon="mdi-checkbox-blank-circle-outline" class="mt-0" :value="gudang.id" @click="checkMethod(gudang.id)"></v-radio>
                                    </v-col>
                                    <v-col cols="10" sm="10" md="10">
                                      <div class="pb-2 d-flex align-center">
                                        <v-icon dense class="cl-purple">mdi-home</v-icon>
                                        <div class="pl-2 my-auto cl-purple font-size-14 font-weight-bold">{{ gudang.name }}</div>
                                      </div>
                                      <div class="grey--text text--darken-1 font-size-11" style="line-height: 1rem;">{{ gudang.address }}</div>
                                      <div class="mt-2 grey--text text--darken-1 font-size-11" style="line-height: 1rem;">Estimasi jarak : {{ gudang.est_distance }} KM</div>
                                      <div class="mt-2 primary--text text--darken-1 font-size-11" style="line-height: 1rem;">Stok produk : <b>100</b></div>
                                    </v-col>
                                  </v-row>
                                </v-card>
                              </v-col>
                            </v-row>
                          </v-radio-group>
                        </template>
                        
                        <template v-else>
                          <div class="d-block text-center">
                            Opsi stokis belum tersedia untuk saat ini.
                          </div>
                        </template>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>

              </v-form>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="">
          <v-spacer></v-spacer>
          <v-row class="text-center">
            <hr>
            <v-btn
              outlined
              class="my-2 px-5 text-capitalize"
              :loading="loadingStatus"
              @click="dialogConfirmChangeStokis = false"
            >
              Batal
            </v-btn>
            <v-btn
              color="primary"
              :loading="loadingStatus"
              class="my-2 px-5 ml-2 text-capitalize white--text"
              @click="kirimPesananAct(selectedItem.trx_dropship_id)"
            >
              Simpan
            </v-btn>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import moment from 'moment'
import modalConfirm from '@/components/ModalDelete'

const defaultInput = () => ({
  nama: '',
  slug: '',
  kategori: '',
  kondisi: '1',
  deskripsi: '',
  minOrder: 0,
  hargaSatuan: '',
  hargaB2b: '',
  status: 'active',
  stok: 0,
  berat: 0,
  unitberat: 0,
  unit: '',
  asuransi: 0,
  image: [],
})

export default {
  component: { moment },
  components: { modalConfirm },
  props: ['allowedStatus', 'payment'], 
  data() {
    return {
      allowChangeResi: false,
      loadingDetail: false,
      loadingStatus: false,
      loadingList: false,
      loadingTransaksi: false,
      loadingBidding: false,
      dialogStatusPesanan:false,
      dialogSellerNotes:false,
      dialogLacak:false,
      dialogCancelOrder:false,
      dialogConfirmTerimaorder: false,
      dialogConfirmKirim: false,
      dialogConfirmChangeStokis: false,
      dialogOpenBidding: false,
      checkedMethod: '',
      produkInput: defaultInput(),
      params: {
        limit: 20,
        page: 0,
        sort: 'trx_datetime',
        dir: 'DESC'
      },
      listPesanan: [],
      listStokis: [],
      pickDate: false,
      pickup_date: '',
      courier_resi: '',
      courier_note: '',
      pickup_time: '',
      noresiRules: [
        v => !!v || 'Nomor resi tidak boleh kosong',
      ],
      pickupTimeRules: [
        v => !!v || 'Pilihan waktu pickup tidak boleh kosong',
      ],
      noPickupdate: [
        v => !!v || 'Tanggal pengambilan tidak boleh kosong',
      ],
      panel: [0],
      menuDate: false,
      filterOptions: [
        {
          label: 'No. Transaksi',
          value: 'invoice'
        },
        // {
        //   label: 'Nama Pembeli',
        //   value: 'buyer'
        // }
      ],
      filter: {
        type: {
          label: 'No. Transaksi',
          value: 'invoice'
        },
        search: '',
        filterId: null,
        sortId: null,
        dateRange: null
      },
      selected: [],
      selectedItem: null,
      expanded: [],
      headers: [
        {
          text: 'Info Pesanan',
          align: 'start',
          sortable: false,
          value: 'trx_code',
        },
        { text: 'action', value: 'data-table-expand' }
      ],
      pembatalanOpt: [
        {
          id: 0,
          label: 'Stok Tidak Tersedia'
        },
        {
          id: 1,
          label: 'Ekspedisi Tutup'
        },
        {
          id: 2,
          label: 'Toko Sudah Tidak Aktif'
        },
        {
          id: 3,
          label: 'Stok di Gudang Rusak'
        }
      ],
      page: 0,
      limit: 20,
      sort: {},
      sortBy: 'trx_datetime',
      sortDir: 'DESC',
      listSort: [
        {
          sortBy: 'product_price',
          sortDir: 'ASC',
          sortLabel: 'Harga Terendah',
        },
        {
          sortBy: 'product_price',
          sortDir: 'DESC',
          sortLabel: 'Harga Tertinggi',
        },
        {
          sortBy: 'product_input_datetime',
          sortDir: 'DESC',
          sortLabel: 'Produk Terbaru',
        },
        {
          sortBy: 'product_sold_count',
          sortDir: 'DESC',
          sortLabel: 'Produk Terlaris',
        },
        {
          sortBy: 'product_view_count',
          sortDir: 'DESC',
          sortLabel: 'Produk Terpopuler',
        },
      ],
      buyerNameFilter: {
        value: '',
        comparison: 'like',
        type: 'string',
        field: 'trx_buyer_user_name'
      },
      invoiceNoFilter: {
        value: '',
        comparison: '=',
        type: 'list',
        field: 'trx_dropship_code',
      },
      tglTransaksiFilter: {
        value: '',
        comparison: 'like',
        type: 'string',
        field: 'trx_dropship_datetime',
      },
      statusFilter: {
        value: '',
        comparison: '=',
        type: 'list',
        field: 'trx_dropship_status',
      },
      paymentFilter: {
        value: 'payment_store',
        comparison: '=',
        type: 'string',
        field: 'trx_payment_method',
      },
      historyStatus: null,
      isMobile: false,
      headerOrderBuyer: [
        {
          text: 'Kode Produk',
          align: 'center',
          sortable: false,
          value: 'product_ref_code',
        },
        { text: 'Nama Produk', align: 'start', value: 'trx_detail_product_name' },
        { text: 'Jumlah', align: 'center', value: 'trx_detail_quantity' },
        { text: 'Harga Jual', align: 'end', value: 'trx_detail_product_price_margin' },
        { text: 'SubTotal', align: 'end', value: 'trx_detail_subtotal_price' }
      ],
      detailOrderBuyer: [],
      
      headerOrderDropship: [
        {
          text: 'Kode Produk',
          align: 'center',
          sortable: false,
          value: 'product_ref_code',
        },
        { text: 'Nama Produk', align: 'start', value: 'trx_dropship_detail_product_name' },
        { text: 'Jumlah', align: 'center', value: 'trx_dropship_detail_quantity' },
        { text: 'Harga Distributor', align: 'end', value: 'trx_dropship_detail_product_price' },
        { text: 'SubTotal', align: 'end', value: 'trx_dropship_detail_subtotal_price' }
      ],
      detailOrderDropship: [],

      headerBidHistory: [
        {
          text: 'Tanggal Update',
          align: 'start',
          // sortable: false,
          value: 'trx_dropship_profit_sharing_status_datetime',
        },
        { text: 'Status', align: 'center', value: 'trx_dropship_profit_sharing_status' },
        { text: 'Total Belanja', align: 'center', value: 'trx_dropship_profit_sharing_trx_nett_price' },
        { text: 'Total Klaim Dropship', align: 'end', value: 'trx_dropship_profit_sharing_claim_dropship_value' },
        { text: 'Ongkos Kirim', align: 'end', value: 'trx_dropship_profit_sharing_trx_shipping_cost' },
        { text: 'Komisi Dropshipper', align: 'end', value: 'trx_dropship_profit_sharing_claim_dropshipper_value' }
      ],
      bidHistory: [],
      showBidHistory: false,
      latestKlaim: {},
      alokasiOngkir: 0,
      klaim: {
        totalKomisiDropshipper: 0,
        totalKlaim: 0,
        setKomisiDropshipper: 0,
        setKlaimValue: 0,
        pvImage: null
      },
      imagePV: null,
      komisiError: {
        klaimDropship: '',
        klaimDropshipper: '',
        pvImage: ''
      },
      rulesKomisi: {
        klaimDropship: [
          v => !!v || 'Nilai klaim tidak boleh kosong',
        ],
        klaimDropshipper: [
          v => !!v || 'Nilai komisi dropshipper wajib diisi',
        ],
        pvImage: [
          // v => !!v || 'Gambar PV harus dilengkapi',
          // v => (v && v.size > 0) || 'Gambar PV harus dilengkapi',
        ]
      },
      shippingMethod: ['Pickup', 'Drop'], //'Manual',
      shippingMethodSelected: '',
      allowToShipping: false,
      loadingTracking: false
    }
  },

  computed: {
    ...mapState('transaksiDropship', ['transaksiDropshipper', 'detailTransaksiDropshipper', 'pickupTimeList', 'shippingLabel', 'trackingDropshipTrx', 'response', 'responseError']),
    
    dateRangeText: {
      get(){
        let dates = (this.filter.dateRange) ? new Date(this.filter.dateRange) : null
        return (dates) ? moment(dates).format('DD MMM YYYY') : null
      },
      set(){
        let dates = (this.filter.dateRange) ? new Date(this.filter.dateRange) : null
        return (dates) ? moment(dates).format('DD MMM YYYY') : null
      } 
    }
  },

  watch: {
    shippingMethodSelected(val) {
      if (val == 'Manual' && this.courier_resi !== '') this.allowToShipping = true
      else if (val == 'Pickup' && this.pickup_time !== '') this.allowToShipping = true
      else if (val == 'Drop') this.allowToShipping = true
      else this.allowToShipping = false
    }
  },

  methods: {
    ...mapActions('transaksiDropship', ['getDropshipperTransaction', 'getDropshipperTransactionDetail', 'processTransaction', 'rejectTransaction', 'deliverTransaction', 'requestBidMargin', 'getTransactionPickupTime', 'getDropshipShippingLabel', 'getTrackingDropshipTrx']),
    ...mapMutations('transaksiDropship', ['clearData']),
    ...mapMutations(['makeAlert']),

    cekAllowToShipping() {
      let val = this.shippingMethodSelected
      if (val == 'Manual' && this.courier_resi !== '') this.allowToShipping = true
      else if (val == 'Pickup' && this.pickup_time !== '') this.allowToShipping = true
      else if (val == 'Drop') this.allowToShipping = true
      else this.allowToShipping = false
    },

    sumField(data, key) {
        return data.reduce((a, b) => parseFloat(a) + parseFloat((b[key] || 0)), 0)
    },

    async getListPesanan() {
      this.loadingList = await true
      let params = await []
      let status = ''

      for(let i=0; i<this.allowedStatus.length; i++) {
        status += (i < (this.allowedStatus.length-1)) ? this.allowedStatus[i] + '::' : this.allowedStatus[i]
      }
      this.statusFilter.value = await status
      this.statusFilter.comparison = (status.split('::').length > 1) ? 'yes' : '='
      if (this.statusFilter.value && (status.split('::').length == 1)) params.push(this.statusFilter)

      this.page = await 1
      await this.getDropshipperTransaction(
        this.queryString({
          limit: this.limit,
          page: this.page,
          sort: 'trx_datetime',
          dir: 'DESC',
          params: params
        })
      ).then(async () => {
        this.listPesanan = await this.pesananData
        this.loadingList = false
      }).catch(() => {
        this.loadingList = true
      })
    },

    filterAllowedStatus(data) {
      let showList = data.filter(d => this.allowedStatus.includes(d.trx_dropship_status))
      return showList
    },

    colorStatus(status) {
      if (status === 'Menunggu Diproses') return 'warning white--text'
      else if (status === 'Menunggu Persetujuan') return 'warning white--text'
      else if (status === 'Diproses') return 'light-green darken-1 white--text'
      else if (status === 'Dikirim') return 'deep-purple darken-1 white--text'
      else if (status === 'Diterima') return 'teal darken-4 white--text'
      else if (status === 'Disetujui') return 'green darken-4 white--text'
      else if (status === 'Selesai') return 'green darken-5 white--text'
      else if (status === 'Dibatalkan') return 'red white--text'
      else if (status === 'Ditolak') return 'red white--text'
    },

    formatDateText(params, format) {
      let dates = (params) ? new Date(params) : null
      return (dates) ? moment(dates).format(format) : null
    },

    async clearDate() {
      this.filter.dateRange = await null
      this.tglTransaksiFilter.value = await this.filter.dateRange
      this.searchTrx()
    },

    async loadDetailTransaksiDropshipper({item}) {
      this.loadingDetail = await true
      this.latestKlaim = await []
      this.bidHistory = await []
      const params = await {
        trx_dropship_id: item.trx_dropship_id
      }
      this.getDropshipperTransactionDetail(params)
        .then(() => {
          this.allowChangeResi = false
          if (this.detailTransaksiDropshipper.profit_sharing.length > 0) {
            this.latestKlaim = this.detailTransaksiDropshipper.profit_sharing[0]
            this.bidHistory = this.detailTransaksiDropshipper.profit_sharing
          }
          // this.courier_note = this.detailTransaksiDropshipper.trx_courier_note
          // this.courier_resi = this.detailTransaksiDropshipper.trx_courier_resi
          // this.pickup_date = this.detailTransaksiDropshipper.trx_pick_up_date

          // const histories = [{
          //   trx_status: 'created',
          //   trx_status_datetime: this.detailTransaksiDropshipper.trx_datetime,
          //   trx_status_desc: 'Pembeli membuat pemesanan baru dari Toko Anda. Menunggu pembayaran dari pembeli.'
          // }, {
          //   trx_status: 'paid',
          //   trx_status_datetime: this.detailTransaksiDropshipper.trx_status_paid_datetime,
          //   trx_status_desc: 'Pembayaran oleh pembeli Berhasil. Pemesanan Barang akan diteruskan ke Penjual.'
          // }, {
          //   trx_status: 'processed',
          //   trx_status_datetime: this.detailTransaksiDropshipper.trx_status_processed_datetime,
          //   trx_status_desc: 'Pesanan sudah diterima Penjual dan diproses ke Pengiriman.'
          // }, {
          //   trx_status: 'on_delivery',
          //   trx_status_datetime: this.detailTransaksiDropshipper.trx_status_on_delivery_datetime,
          //   trx_status_desc: 'Pesanan telah dikirimkan dengan nomor resi ' + this.courier_resi + ' .'
          // }, {
          //   trx_status: 'completed',
          //   trx_status_datetime: this.detailTransaksiDropshipper.trx_status_completed_datetime,
          //   trx_status_desc: 'Pemesanan telah selesai dan diterima oleh Pembeli.'
          // }, {
          //   trx_status: 'cancel',
          //   trx_status_datetime: this.detailTransaksiDropshipper.trx_status_cancel_datetime,
          //   trx_status_desc: 'Pemesanan Anda telah dibatalkan.'
          // }, {
          //   trx_status: 'rejected_admin',
          //   trx_status_datetime: this.detailTransaksiDropshipper.trx_status_rejected_admin_datetime,
          //   trx_status_desc: 'Pemesanan Anda tidak disetujui oleh HWI Ecommerce.'
          // }]
          // const sortedActivities = histories.sort((a, b) => {
          //   if (a.trx_status_datetime > b.trx_status_datetime) return -1
          //   if (a.trx_status_datetime < b.trx_status_datetime) return 1
          //   return 0
          // })
          // this.historyStatus = sortedActivities

          setTimeout(() => {
            this.loadingDetail = false
          }, 1000);
        }).catch(() => {
          this.loadingDetail = false
        })
    },

    setSlugProduct(id, nama) {
      return id + '-' + (nama.toLowerCase()).replace(/ /g, '-')
    },

    async searchTrx() {
      this.loadingList = await true
      let params = await []
      if (this.filter.type.value === 'buyer') {
        if (this.buyerNameFilter.value) await params.push(this.buyerNameFilter)
      } else {
        if (this.invoiceNoFilter.value) await params.push(this.invoiceNoFilter)
      }
      if (this.tglTransaksiFilter.value) await params.push(this.tglTransaksiFilter)

      if (this.allowedStatus.length === 1) this.statusFilter.value = await this.allowedStatus
      if (this.statusFilter.value) await params.push(this.statusFilter)

      this.page = await 1
      await this.getDropshipperTransaction(
        this.queryString({
          limit: this.limit,
          page: this.page,
          sort: 'trx_datetime',
          dir: 'DESC',
          params: params
        })
      ).then(async () => {
        this.listPesanan = await this.filterAllowedStatus(this.pesananData)
        this.loadingList = false
      }).catch(() => {
        this.loadingList = false
      })
    },

    async clearSearch() {
      this.filter.search = await ''
      this.filter.type = await {
        label: 'No. Transaksi',
        value: 'invoice'
      }
      this.buyerNameFilter.value = await ''
      this.invoiceNoFilter.value = await ''
      this.searchTrx()
    },

    async updatePage(val) {
      this.loadingList = await true
      let params = await []
      let status = ''

      for(let i=0; i<this.allowedStatus.length; i++) {
        status += (i < (this.allowedStatus.length-1)) ? this.allowedStatus[i] + '::' : this.allowedStatus[i]
      }
      this.statusFilter.value = await status
      if (this.statusFilter.value) params.push(this.statusFilter)

      await this.getDropshipperTransaction(
        this.queryString({limit : 20, page : val, sort: 'trx_datetime', dir: 'DESC', params: params})
      ).then(async () => {
        this.listPesanan = await this.pesananData
        this.loadingList = false
      }).catch(() => {
        this.loadingList = false
      })
    },

    async openConfirmProses(item) {
      this.selectedItem = await item
      this.dialogConfirmTerimaorder = true
    },

    async openConfirmReject(item) {
      this.selectedItem = await item
      this.$refs.modalCancel.modalShow()
    },

    async openConfirmKirim(item) {
      if (this.$refs.formKirimPesanan.validate()) {
        this.selectedItem = await item
        this.dialogConfirmKirim = true
      }
    },

    async openConfirmChangeResi(item) {
      if (this.$refs.formChangeResi.validate()) {
        this.selectedItem = await item
        this.dialogConfirmTerimaorder = true
      }
    },

    openBidHistory() {
      this.showBidHistory = !this.showBidHistory
      var myDiv = document.getElementById('bidHistoryContent');
      myDiv.scrollTop = 0;
    },

    async openBiddingDialog() {
      if (Object.keys(this.detailTransaksiDropshipper).length > 0) {
        if (this.detailTransaksiDropshipper.profit_sharing.length > 0) {
          this.latestKlaim = await this.detailTransaksiDropshipper.profit_sharing[0]
          this.bidHistory = await this.detailTransaksiDropshipper.profit_sharing
        }
        this.detailOrderBuyer = await this.detailTransaksiDropshipper.trx_detail
        this.detailOrderDropship = await this.detailTransaksiDropshipper.trx_dropship_detail
        // {{ ((detailTransaksiDropshipper.trx.trx_total_margin - detailTransaksiDropshipper.trx.free_delivery - detailTransaksiDropshipper.trx_dropship_subtotal_price) - ((detailTransaksiDropshipper.trx.discount > 0) ? 0 : (detailTransaksiDropshipper.trx_shipping.trx_shipping_courier_total_price - detailTransaksiDropshipper.trx.free_delivery)) + (detailTransaksiDropshipper.trx_shipping.trx_shipping_courier_total_price - detailTransaksiDropshipper.trx_dropship_shipping.trx_dropship_shipping_courier_total_price)) | toNumber }}
        this.klaim.totalKomisiDropshipper = await ((this.detailTransaksiDropshipper.trx.trx_total_margin - this.detailTransaksiDropshipper.trx.free_delivery - this.detailTransaksiDropshipper.trx_dropship_subtotal_price - this.detailTransaksiDropshipper.trx.discount) - ((this.detailTransaksiDropshipper.trx.discount > 0) ? 0 : (this.detailTransaksiDropshipper.trx_shipping.trx_shipping_courier_total_price - this.detailTransaksiDropshipper.trx.free_delivery)) + (this.detailTransaksiDropshipper.trx_shipping.trx_shipping_courier_total_price - this.detailTransaksiDropshipper.trx_dropship_shipping.trx_dropship_shipping_courier_total_price))
        // if (this.detailTransaksiDropshipper.seller.store_free_delivery == 'Ya') this.klaim.totalKomisiDropshipper = await ((this.detailTransaksiDropshipper.trx.trx_total_margin - this.detailTransaksiDropshipper.trx.free_delivery - this.detailTransaksiDropshipper.trx_dropship_subtotal_price - this.detailTransaksiDropshipper.trx.discount) - ((this.detailTransaksiDropshipper.trx.discount > 0) ? 0 : (this.detailTransaksiDropshipper.trx_shipping.trx_shipping_courier_total_price - this.detailTransaksiDropshipper.trx.free_delivery)) + (this.detailTransaksiDropshipper.trx_shipping.trx_shipping_courier_total_price - this.detailTransaksiDropshipper.trx_dropship_shipping.trx_dropship_shipping_courier_total_price))
        // else if (this.detailTransaksiDropshipper.seller.store_free_delivery == 'Tidak') this.klaim.totalKomisiDropshipper = await ((this.detailTransaksiDropshipper.trx.trx_total_margin - this.detailTransaksiDropshipper.trx.free_delivery - this.detailTransaksiDropshipper.trx_dropship_subtotal_price - this.detailTransaksiDropshipper.trx.discount) + parseFloat((this.detailTransaksiDropshipper.trx_shipping.trx_shipping_courier_total_price - this.detailTransaksiDropshipper.trx_dropship_shipping.trx_dropship_shipping_courier_total_price)))
        
        this.klaim.totalKlaim = await (parseFloat(this.detailTransaksiDropshipper.trx_dropship_subtotal_price))
        // this.klaim.totalKlaim = await (parseFloat(this.detailTransaksiDropshipper.trx_dropship_subtotal_price) + parseFloat(this.detailTransaksiDropshipper.trx_dropship_shipping.trx_dropship_shipping_courier_total_price))
        // if (this.detailTransaksiDropshipper.seller.store_free_delivery == 'Ya') this.klaim.totalKlaim = await (parseFloat(this.detailTransaksiDropshipper.trx_dropship_subtotal_price) + parseFloat(this.detailTransaksiDropshipper.trx_dropship_shipping.trx_dropship_shipping_courier_total_price))
        // else if (this.detailTransaksiDropshipper.seller.store_free_delivery == 'Tidak') this.klaim.totalKlaim = await (parseFloat(this.detailTransaksiDropshipper.trx_dropship_subtotal_price))
        
        // console.log('detailOrderBuyer', this.detailTransaksiDropshipper)
        // this.alokasiOngkir = this.detailOrderBuyer.reduce((accumulator, current) => parseInt(accumulator) + parseInt(current.trx_detail_quantity), 0)
        this.klaim.setKomisiDropshipper = (Object.keys(this.latestKlaim).length > 0) ? (this.latestKlaim.trx_dropship_profit_sharing_status !== 'Ditolak') ? this.latestKlaim.trx_dropship_profit_sharing_claim_dropshipper_value : this.klaim.totalKomisiDropshipper : this.klaim.totalKomisiDropshipper
        this.klaim.setKlaimValue = (Object.keys(this.latestKlaim).length > 0) ? this.latestKlaim.trx_dropship_profit_sharing_claim_dropship_value : this.klaim.totalKlaim
 
        this.klaim.pvImage = null
        this.imagePV = null
        this.dialogOpenBidding = true
      }
    },

    async resetBidding() {
      if (Object.keys(this.detailTransaksiDropshipper).length > 0) {
        if (this.detailTransaksiDropshipper.profit_sharing.length > 0) {
          this.latestKlaim = await this.detailTransaksiDropshipper.profit_sharing[0]
          this.bidHistory = await this.detailTransaksiDropshipper.profit_sharing
        }
        this.detailOrderBuyer = await this.detailTransaksiDropshipper.trx_detail
        this.detailOrderDropship = await this.detailTransaksiDropshipper.trx_dropship_detail
        
        if (this.detailTransaksiDropshipper.seller.store_free_delivery == 'Ya') this.klaim.totalKomisiDropshipper = await ((this.detailTransaksiDropshipper.trx.trx_total_margin - this.detailTransaksiDropshipper.trx.free_delivery - this.detailTransaksiDropshipper.trx_dropship_subtotal_price - this.detailTransaksiDropshipper.trx.discount) - ((this.detailTransaksiDropshipper.trx.discount > 0) ? 0 : (this.detailTransaksiDropshipper.trx_shipping.trx_shipping_courier_total_price - this.detailTransaksiDropshipper.trx.free_delivery)) + (this.detailTransaksiDropshipper.trx_shipping.trx_shipping_courier_total_price - this.detailTransaksiDropshipper.trx_dropship_shipping.trx_dropship_shipping_courier_total_price))
        else if (this.detailTransaksiDropshipper.seller.store_free_delivery == 'Tidak') this.klaim.totalKomisiDropshipper = await ((this.detailTransaksiDropshipper.trx.trx_total_margin - this.detailTransaksiDropshipper.trx.free_delivery - this.detailTransaksiDropshipper.trx_dropship_subtotal_price - this.detailTransaksiDropshipper.trx.discount) + parseFloat((this.detailTransaksiDropshipper.trx_shipping.trx_shipping_courier_total_price - this.detailTransaksiDropshipper.trx_dropship_shipping.trx_dropship_shipping_courier_total_price)))
        
        if (this.detailTransaksiDropshipper.seller.store_free_delivery == 'Ya') this.klaim.totalKlaim = await (parseFloat(this.detailTransaksiDropshipper.trx_dropship_subtotal_price) + parseFloat(this.detailTransaksiDropshipper.trx_dropship_shipping.trx_dropship_shipping_courier_total_price))
        else if (this.detailTransaksiDropshipper.seller.store_free_delivery == 'Tidak') this.klaim.totalKlaim = await (parseFloat(this.detailTransaksiDropshipper.trx_dropship_subtotal_price))
        
        this.klaim.setKomisiDropshipper = (Object.keys(this.latestKlaim).length > 0) ? (this.latestKlaim.trx_dropship_profit_sharing_status !== 'Ditolak') ? this.latestKlaim.trx_dropship_profit_sharing_claim_dropshipper_value : this.klaim.totalKomisiDropshipper : this.klaim.totalKomisiDropshipper
        this.klaim.setKlaimValue = (Object.keys(this.latestKlaim).length > 0) ? this.latestKlaim.trx_dropship_profit_sharing_claim_dropship_value : this.klaim.totalKlaim
 
        this.klaim.pvImage = null
        this.imagePV = null
        this.dialogOpenBidding = false
      }
    },

    async inputDropshipShare() {
      let klaimDropship = 0
      let komisiDropshipper = 0

      if (this.detailTransaksiDropshipper.seller.store_free_delivery == 'Ya') komisiDropshipper = await ((this.detailTransaksiDropshipper.trx.trx_total_margin - this.detailTransaksiDropshipper.trx.free_delivery - this.detailTransaksiDropshipper.trx_dropship_subtotal_price - this.detailTransaksiDropshipper.trx.discount) - ((this.detailTransaksiDropshipper.trx.discount > 0) ? 0 : (this.detailTransaksiDropshipper.trx_shipping.trx_shipping_courier_total_price - this.detailTransaksiDropshipper.trx.free_delivery)) + (this.detailTransaksiDropshipper.trx_shipping.trx_shipping_courier_total_price - this.detailTransaksiDropshipper.trx_dropship_shipping.trx_dropship_shipping_courier_total_price))
      else if (this.detailTransaksiDropshipper.seller.store_free_delivery == 'Tidak') komisiDropshipper = await ((this.detailTransaksiDropshipper.trx.trx_total_margin - this.detailTransaksiDropshipper.trx.free_delivery - this.detailTransaksiDropshipper.trx_dropship_subtotal_price - this.detailTransaksiDropshipper.trx.discount) + parseFloat((this.detailTransaksiDropshipper.trx_shipping.trx_shipping_courier_total_price - this.detailTransaksiDropshipper.trx_dropship_shipping.trx_dropship_shipping_courier_total_price)))
      
      if (this.detailTransaksiDropshipper.seller.store_free_delivery == 'Ya') klaimDropship = await (parseFloat(this.detailTransaksiDropshipper.trx_dropship_subtotal_price) + parseFloat(this.detailTransaksiDropshipper.trx_dropship_shipping.trx_dropship_shipping_courier_total_price))
      else if (this.detailTransaksiDropshipper.seller.store_free_delivery == 'Tidak') klaimDropship = await (parseFloat(this.detailTransaksiDropshipper.trx_dropship_subtotal_price))

      let setKlaim = await parseFloat(komisiDropshipper) - parseFloat(this.klaim.setKomisiDropshipper)
      
      if (setKlaim > 0) this.klaim.setKlaimValue = parseFloat(klaimDropship) + parseFloat(setKlaim)
      else this.klaim.setKlaimValue = parseFloat(klaimDropship) + parseFloat(setKlaim)
    },

    async inputClaimShare() {
      let klaimDropship = 0
      let komisiDropshipper = 0

      if (this.detailTransaksiDropshipper.seller.store_free_delivery == 'Ya') komisiDropshipper = await ((this.detailTransaksiDropshipper.trx.trx_total_margin - this.detailTransaksiDropshipper.trx.free_delivery - this.detailTransaksiDropshipper.trx_dropship_subtotal_price - this.detailTransaksiDropshipper.trx.discount) - ((this.detailTransaksiDropshipper.trx.discount > 0) ? 0 : (this.detailTransaksiDropshipper.trx_shipping.trx_shipping_courier_total_price - this.detailTransaksiDropshipper.trx.free_delivery)) + (this.detailTransaksiDropshipper.trx_shipping.trx_shipping_courier_total_price - this.detailTransaksiDropshipper.trx_dropship_shipping.trx_dropship_shipping_courier_total_price))
      else if (this.detailTransaksiDropshipper.seller.store_free_delivery == 'Tidak') komisiDropshipper = await ((this.detailTransaksiDropshipper.trx.trx_total_margin - this.detailTransaksiDropshipper.trx.free_delivery - this.detailTransaksiDropshipper.trx_dropship_subtotal_price - this.detailTransaksiDropshipper.trx.discount) + parseFloat((this.detailTransaksiDropshipper.trx_shipping.trx_shipping_courier_total_price - this.detailTransaksiDropshipper.trx_dropship_shipping.trx_dropship_shipping_courier_total_price)))
      
      if (this.detailTransaksiDropshipper.seller.store_free_delivery == 'Ya') klaimDropship = await (parseFloat(this.detailTransaksiDropshipper.trx_dropship_subtotal_price))
      else if (this.detailTransaksiDropshipper.seller.store_free_delivery == 'Tidak') klaimDropship = await (parseFloat(this.detailTransaksiDropshipper.trx_dropship_subtotal_price))

      let setKlaim = await parseFloat(klaimDropship) - parseFloat(this.klaim.setKlaimValue)

      if (setKlaim > 0) this.klaim.setKomisiDropshipper = parseFloat(komisiDropshipper) + parseFloat(setKlaim)
      else this.klaim.setKomisiDropshipper = parseFloat(komisiDropshipper) + parseFloat(setKlaim)
    },

    async openUpload() {
			const input = await document.getElementById('inputImage')
			input.click()
		},
		handleFileUpload(event) {
			// this.formData.append('trx_payment_bank_trf_transfer_image', event);
      this.klaim.pvImage = event

			if (!event)
				return;

			this.createImage(event);
		},
		createImage(file) {
			var reader = new FileReader();

			reader.onload = (e) => {
				this.imagePV = e.target.result;
			};
			reader.readAsDataURL(file);
		},

    async submitRequestBid() {
      this.loadingBidding = await true

      // if (this.klaim.pvImage) {
        this.komisiError.pvImage = ''
        if (this.$refs.formKomisi.validate()) {
    
          let params = new FormData()
          params.append('trx_dropship_id', this.detailTransaksiDropshipper.trx_dropship_id)
          params.append('trx_dropship_profit_sharing_claim_dropship_value', this.klaim.setKlaimValue)
          params.append('trx_dropship_profit_sharing_claim_dropshipper_value', this.klaim.setKomisiDropshipper)
          params.append('trx_dropship_profit_sharing_image', this.klaim.pvImage)
          // this.requestBidMargin()
          this.requestBidMargin(params).then(() => {
            this.dialogOpenBidding = false
            this.getListPesanan()
    
            setTimeout(() => {
              this.loadingBidding = false
              location.reload()
            }, 600);
          })
          .catch(() => {
            this.loadingBidding = false
          })
          .finally(() => {
            setTimeout(() => {
              this.loadingBidding = false
              location.replace(location.href)
            }, 600);
          })
        } else {
          this.loadingBidding = false
        }
      // } else {
        // this.komisiError.pvImage = 'Gambar PV harus dilengkapi'
      //   this.loadingBidding = false
      // }
    },

    async prosesPesananAct() {
      this.loadingStatus = await true
      this.loadingList = await true
      const params = await {
        trx_dropship_id: this.selectedItem.trx_dropship_id,
      }

      await this.processTransaction(params)
      .then(async() => {
        await this.makeAlert({ code: 'success', type: 'success', message: this.response.message, show: true })
        this.dialogConfirmTerimaorder = await false
        // location.reload()
      })
      .catch(() => {
        this.selectedItem = null
        this.dialogConfirmTerimaorder = false
        this.loadingStatus = false
        this.loadingList = false
      })
      .finally(() => {
        location.replace(location.href)
      })
    },

    async rejectPesananAct() {
      this.loadingStatus = await true
      this.loadingList = await true
      
      const params = await {
        trx_dropship_id: this.selectedItem.trx_dropship_id,
        type: 'dropshipper'
      }

      await this.rejectTransaction(params)
      .then(async() => {
        await this.makeAlert({ code: 'success', type: 'success', message: this.response.message, show: true })
        this.$refs.modalCancel.modalHide()
        // location.reload()
      })
      .catch(() => {
        this.selectedItem = null
        this.$refs.modalCancel.modalHide()
        this.loadingStatus = false
        this.loadingList = false
      })
      .finally(() => {
        location.replace(location.href)
      })
    },

     async ubahResi(id) {
      this.loadingStatus = await true
      const params = await {
        trx_dropship_id: id,
        trx_courier_resi: this.courier_resi,
      }

      await this.changeResi(params)
      .then(async() => {
        await this.makeAlert({ code: 'success', type: 'success', message: this.response.message, show: true })
         await this.getListPesanan()
          await this.getStatusPesanan()
          await this.loadDetailTransaksiDropshipper({
            item: params
          })
          this.selectedItem = await null
          this.dialogConfirmTerimaorder = await false
          this.loadingStatus = false
          this.loadingList = false
          this.allowChangeResi = false
      })
      .catch(() => {
        this.selectedItem = null
        this.dialogConfirmTerimaorder = false
        this.loadingStatus = false
        this.loadingList = false
      })
    },

    async kirimPesananAct() {
      this.loadingStatus = await true
      this.loadingList = await true
      const params = await {
        trx_dropship_id: this.selectedItem.trx_dropship_id,
        trx_dropship_shipping_courier_awb_number: this.courier_resi,
        trx_dropship_shipping_courier_type: this.shippingMethodSelected,
        trx_dropship_shipping_courier_pickup_datetime: moment(this.pickup_time).format('YYYY-MM-DD HH:mm:ss')
        // trx_courier_note: this.courier_note
      }

      await this.deliverTransaction(params)
      .then(async() => {
        await this.makeAlert({ code: 'success', type: 'success', message: this.response.message, show: true })
        this.dialogConfirmKirim = await false
        // location.reload()
        // await this.loadDetailTransaksiDropshipper({
        //   item: params
        // })
        // await this.getListPesanan()
        // await this.getStatusPesanan()
        // this.selectedItem = await null
        // this.loadingStatus = false
        // this.loadingList = false
      })
      .catch(() => {
        this.selectedItem = null
        this.dialogConfirmKirim = false
        this.loadingStatus = false
        this.loadingList = false
      })
      .finally(() => {
        location.replace(location.href)
      })
      // location.reload()
    },

    async openPrintShippingLabel(data) {
      this.loadingStatus = await true
      const params = {
        trx_dropship_id: data.trx_dropship_id
      }
      await this.getDropshipShippingLabel(params)
      .then(() => {
        if(this.shippingLabel.data !== '') window.open(this.shippingLabel.data, '_blank');
        setTimeout(() => {
          this.loadingStatus = false
        }, 1000)
      })
      .catch(() => { this.loadingStatus = false })
    },

    async loadTrxTracking(trx_id) {
      this.loadingTracking = await true
      const params = await {
        trx_dropship_id: trx_id
      }

      await this.getTrackingDropshipTrx(params)
      .then(async() => {
        this.dialogLacak = true
        
        setTimeout(() => {
          this.loadingTracking = false
        }, 1500);
      })
      .catch(() => {
        this.loadingTracking = false
        this.dialogLacak = false
      })
      this.loadingTracking = false
    },

    async pengambilanPesananAct(id, date) {
      this.loadingStatus = await true
      const params = await {
        trx_dropship_id: id,
        pick_up_date: date,
        trx_courier_note: this.courier_note
      }

      await this.pickupStore(params)
      .then(async() => {
        await this.makeAlert({ code: 'success', type: 'success', message: this.response.message, show: true })
        await this.loadDetailTransaksiDropshipper({
          item: params
        })
        await this.getListPesanan()
        await this.getStatusPesanan()
        this.selectedItem = await null
        this.dialogConfirmKirim = await false
        this.loadingStatus = false
      })
      .catch(() => {
        this.selectedItem = null
        this.dialogConfirmKirim = false
        this.loadingStatus = false
      })
    },

    onResize() {
      if (window.innerWidth < 769)
        this.isMobile = true;
      else
        this.isMobile = false;
    },

    printInvoice(id) {
      let routeData = this.$router.resolve({ path : '/seller/invoice/' + id})
			window.open(routeData.href, '_blank');
    },
    confirmPayment(data) {
      this.paymentStorePaid({
        trx_dropship_id: data.trx_dropship_id
      }).then(async() => {
        await this.makeAlert({ code: 'success', type: 'success', message: this.response.message, show: true })
        await this.getListPesanan()
        await this.getStatusPesanan()
        this.loadingStatus = false
      }).catch(() => {
        this.loadingStatus = false
      })
    },
    cancelTransaction(data) {
      this.paymentStoreCancel({
        trx_dropship_id: data.trx_dropship_id
      }).then(async() => {
        await this.makeAlert({ code: 'success', type: 'success', message: this.response.message, show: true })
        await this.getListPesanan()
        await this.getStatusPesanan()
        this.loadingStatus = false
      }).catch(() => {
        this.loadingStatus = false
      })
    }
  },

  async mounted() {
    await this.getListPesanan()
    await this.getTransactionPickupTime()
  },

  eforeDestroy() {
    this.clearData()
  }
}
</script>

<style lang="scss" scoped>
  .v-spacer {
    width: 1px;
    height: 30px;;
    background: transparent;
    display: block;
    position: relative;
    margin: 0 auto;
    border-left: 3px dotted #ccc;
  }
</style>